const tokens = {
  "aspectRatios.square": {
    "value": "1 / 1",
    "variable": "var(--aspect-ratios-square)"
  },
  "aspectRatios.landscape": {
    "value": "4 / 3",
    "variable": "var(--aspect-ratios-landscape)"
  },
  "aspectRatios.portrait": {
    "value": "3 / 4",
    "variable": "var(--aspect-ratios-portrait)"
  },
  "aspectRatios.wide": {
    "value": "16 / 9",
    "variable": "var(--aspect-ratios-wide)"
  },
  "aspectRatios.ultrawide": {
    "value": "18 / 5",
    "variable": "var(--aspect-ratios-ultrawide)"
  },
  "aspectRatios.golden": {
    "value": "1.618 / 1",
    "variable": "var(--aspect-ratios-golden)"
  },
  "borders.none": {
    "value": "none",
    "variable": "var(--borders-none)"
  },
  "easings.default": {
    "value": "cubic-bezier(0.4, 0, 0.2, 1)",
    "variable": "var(--easings-default)"
  },
  "easings.linear": {
    "value": "linear",
    "variable": "var(--easings-linear)"
  },
  "easings.in": {
    "value": "cubic-bezier(0.4, 0, 1, 1)",
    "variable": "var(--easings-in)"
  },
  "easings.out": {
    "value": "cubic-bezier(0, 0, 0.2, 1)",
    "variable": "var(--easings-out)"
  },
  "easings.in-out": {
    "value": "cubic-bezier(0.4, 0, 0.2, 1)",
    "variable": "var(--easings-in-out)"
  },
  "durations.fastest": {
    "value": "50ms",
    "variable": "var(--durations-fastest)"
  },
  "durations.faster": {
    "value": "100ms",
    "variable": "var(--durations-faster)"
  },
  "durations.fast": {
    "value": "150ms",
    "variable": "var(--durations-fast)"
  },
  "durations.normal": {
    "value": "200ms",
    "variable": "var(--durations-normal)"
  },
  "durations.slow": {
    "value": "300ms",
    "variable": "var(--durations-slow)"
  },
  "durations.slower": {
    "value": "400ms",
    "variable": "var(--durations-slower)"
  },
  "durations.slowest": {
    "value": "500ms",
    "variable": "var(--durations-slowest)"
  },
  "radii.xs": {
    "value": "0.125rem",
    "variable": "var(--radii-xs)"
  },
  "radii.sm": {
    "value": "0.25rem",
    "variable": "var(--radii-sm)"
  },
  "radii.md": {
    "value": "0.375rem",
    "variable": "var(--radii-md)"
  },
  "radii.lg": {
    "value": "0.5rem",
    "variable": "var(--radii-lg)"
  },
  "radii.xl": {
    "value": "0.75rem",
    "variable": "var(--radii-xl)"
  },
  "radii.2xl": {
    "value": "1rem",
    "variable": "var(--radii-2xl)"
  },
  "radii.3xl": {
    "value": "1.5rem",
    "variable": "var(--radii-3xl)"
  },
  "radii.4xl": {
    "value": "2rem",
    "variable": "var(--radii-4xl)"
  },
  "radii.full": {
    "value": "9999px",
    "variable": "var(--radii-full)"
  },
  "fontWeights.thin": {
    "value": "100",
    "variable": "var(--font-weights-thin)"
  },
  "fontWeights.extralight": {
    "value": "200",
    "variable": "var(--font-weights-extralight)"
  },
  "fontWeights.light": {
    "value": "300",
    "variable": "var(--font-weights-light)"
  },
  "fontWeights.normal": {
    "value": "400",
    "variable": "var(--font-weights-normal)"
  },
  "fontWeights.medium": {
    "value": "500",
    "variable": "var(--font-weights-medium)"
  },
  "fontWeights.semibold": {
    "value": "600",
    "variable": "var(--font-weights-semibold)"
  },
  "fontWeights.bold": {
    "value": "700",
    "variable": "var(--font-weights-bold)"
  },
  "fontWeights.extrabold": {
    "value": "800",
    "variable": "var(--font-weights-extrabold)"
  },
  "fontWeights.black": {
    "value": "900",
    "variable": "var(--font-weights-black)"
  },
  "lineHeights.none": {
    "value": "1",
    "variable": "var(--line-heights-none)"
  },
  "lineHeights.tight": {
    "value": "1.25",
    "variable": "var(--line-heights-tight)"
  },
  "lineHeights.snug": {
    "value": "1.375",
    "variable": "var(--line-heights-snug)"
  },
  "lineHeights.normal": {
    "value": "1.5",
    "variable": "var(--line-heights-normal)"
  },
  "lineHeights.relaxed": {
    "value": "1.625",
    "variable": "var(--line-heights-relaxed)"
  },
  "lineHeights.loose": {
    "value": "2",
    "variable": "var(--line-heights-loose)"
  },
  "letterSpacings.tighter": {
    "value": "-0.05em",
    "variable": "var(--letter-spacings-tighter)"
  },
  "letterSpacings.tight": {
    "value": "-0.025em",
    "variable": "var(--letter-spacings-tight)"
  },
  "letterSpacings.normal": {
    "value": "0em",
    "variable": "var(--letter-spacings-normal)"
  },
  "letterSpacings.wide": {
    "value": "0.025em",
    "variable": "var(--letter-spacings-wide)"
  },
  "letterSpacings.wider": {
    "value": "0.05em",
    "variable": "var(--letter-spacings-wider)"
  },
  "letterSpacings.widest": {
    "value": "0.1em",
    "variable": "var(--letter-spacings-widest)"
  },
  "blurs.xs": {
    "value": "4px",
    "variable": "var(--blurs-xs)"
  },
  "blurs.sm": {
    "value": "8px",
    "variable": "var(--blurs-sm)"
  },
  "blurs.md": {
    "value": "12px",
    "variable": "var(--blurs-md)"
  },
  "blurs.lg": {
    "value": "16px",
    "variable": "var(--blurs-lg)"
  },
  "blurs.xl": {
    "value": "24px",
    "variable": "var(--blurs-xl)"
  },
  "blurs.2xl": {
    "value": "40px",
    "variable": "var(--blurs-2xl)"
  },
  "blurs.3xl": {
    "value": "64px",
    "variable": "var(--blurs-3xl)"
  },
  "spacing.0": {
    "value": "0rem",
    "variable": "var(--spacing-0)"
  },
  "spacing.1": {
    "value": "0.25rem",
    "variable": "var(--spacing-1)"
  },
  "spacing.2": {
    "value": "0.5rem",
    "variable": "var(--spacing-2)"
  },
  "spacing.3": {
    "value": "0.75rem",
    "variable": "var(--spacing-3)"
  },
  "spacing.4": {
    "value": "1rem",
    "variable": "var(--spacing-4)"
  },
  "spacing.5": {
    "value": "1.25rem",
    "variable": "var(--spacing-5)"
  },
  "spacing.6": {
    "value": "1.5rem",
    "variable": "var(--spacing-6)"
  },
  "spacing.7": {
    "value": "1.75rem",
    "variable": "var(--spacing-7)"
  },
  "spacing.8": {
    "value": "2rem",
    "variable": "var(--spacing-8)"
  },
  "spacing.9": {
    "value": "2.25rem",
    "variable": "var(--spacing-9)"
  },
  "spacing.10": {
    "value": "2.5rem",
    "variable": "var(--spacing-10)"
  },
  "spacing.11": {
    "value": "2.75rem",
    "variable": "var(--spacing-11)"
  },
  "spacing.12": {
    "value": "3rem",
    "variable": "var(--spacing-12)"
  },
  "spacing.14": {
    "value": "3.5rem",
    "variable": "var(--spacing-14)"
  },
  "spacing.16": {
    "value": "4rem",
    "variable": "var(--spacing-16)"
  },
  "spacing.20": {
    "value": "5rem",
    "variable": "var(--spacing-20)"
  },
  "spacing.24": {
    "value": "6rem",
    "variable": "var(--spacing-24)"
  },
  "spacing.28": {
    "value": "7rem",
    "variable": "var(--spacing-28)"
  },
  "spacing.32": {
    "value": "8rem",
    "variable": "var(--spacing-32)"
  },
  "spacing.36": {
    "value": "9rem",
    "variable": "var(--spacing-36)"
  },
  "spacing.40": {
    "value": "10rem",
    "variable": "var(--spacing-40)"
  },
  "spacing.44": {
    "value": "11rem",
    "variable": "var(--spacing-44)"
  },
  "spacing.48": {
    "value": "12rem",
    "variable": "var(--spacing-48)"
  },
  "spacing.52": {
    "value": "13rem",
    "variable": "var(--spacing-52)"
  },
  "spacing.56": {
    "value": "14rem",
    "variable": "var(--spacing-56)"
  },
  "spacing.60": {
    "value": "15rem",
    "variable": "var(--spacing-60)"
  },
  "spacing.64": {
    "value": "16rem",
    "variable": "var(--spacing-64)"
  },
  "spacing.72": {
    "value": "18rem",
    "variable": "var(--spacing-72)"
  },
  "spacing.80": {
    "value": "20rem",
    "variable": "var(--spacing-80)"
  },
  "spacing.96": {
    "value": "24rem",
    "variable": "var(--spacing-96)"
  },
  "spacing.0.5": {
    "value": "0.125rem",
    "variable": "var(--spacing-0\\.5)"
  },
  "spacing.1.5": {
    "value": "0.375rem",
    "variable": "var(--spacing-1\\.5)"
  },
  "spacing.2.5": {
    "value": "0.625rem",
    "variable": "var(--spacing-2\\.5)"
  },
  "spacing.3.5": {
    "value": "0.875rem",
    "variable": "var(--spacing-3\\.5)"
  },
  "spacing.4.5": {
    "value": "1.125rem",
    "variable": "var(--spacing-4\\.5)"
  },
  "spacing.5.5": {
    "value": "1.375rem",
    "variable": "var(--spacing-5\\.5)"
  },
  "colors.rose.50": {
    "value": "#fff1f2",
    "variable": "var(--colors-rose-50)"
  },
  "colors.rose.100": {
    "value": "#ffe4e6",
    "variable": "var(--colors-rose-100)"
  },
  "colors.rose.200": {
    "value": "#fecdd3",
    "variable": "var(--colors-rose-200)"
  },
  "colors.rose.300": {
    "value": "#fda4af",
    "variable": "var(--colors-rose-300)"
  },
  "colors.rose.400": {
    "value": "#fb7185",
    "variable": "var(--colors-rose-400)"
  },
  "colors.rose.500": {
    "value": "#f43f5e",
    "variable": "var(--colors-rose-500)"
  },
  "colors.rose.600": {
    "value": "#e11d48",
    "variable": "var(--colors-rose-600)"
  },
  "colors.rose.700": {
    "value": "#be123c",
    "variable": "var(--colors-rose-700)"
  },
  "colors.rose.800": {
    "value": "#9f1239",
    "variable": "var(--colors-rose-800)"
  },
  "colors.rose.900": {
    "value": "#881337",
    "variable": "var(--colors-rose-900)"
  },
  "colors.rose.950": {
    "value": "#4c0519",
    "variable": "var(--colors-rose-950)"
  },
  "colors.fuchsia.50": {
    "value": "#fdf4ff",
    "variable": "var(--colors-fuchsia-50)"
  },
  "colors.fuchsia.100": {
    "value": "#fae8ff",
    "variable": "var(--colors-fuchsia-100)"
  },
  "colors.fuchsia.200": {
    "value": "#f5d0fe",
    "variable": "var(--colors-fuchsia-200)"
  },
  "colors.fuchsia.300": {
    "value": "#f0abfc",
    "variable": "var(--colors-fuchsia-300)"
  },
  "colors.fuchsia.400": {
    "value": "#e879f9",
    "variable": "var(--colors-fuchsia-400)"
  },
  "colors.fuchsia.500": {
    "value": "#d946ef",
    "variable": "var(--colors-fuchsia-500)"
  },
  "colors.fuchsia.600": {
    "value": "#c026d3",
    "variable": "var(--colors-fuchsia-600)"
  },
  "colors.fuchsia.700": {
    "value": "#a21caf",
    "variable": "var(--colors-fuchsia-700)"
  },
  "colors.fuchsia.800": {
    "value": "#86198f",
    "variable": "var(--colors-fuchsia-800)"
  },
  "colors.fuchsia.900": {
    "value": "#701a75",
    "variable": "var(--colors-fuchsia-900)"
  },
  "colors.fuchsia.950": {
    "value": "#4a044e",
    "variable": "var(--colors-fuchsia-950)"
  },
  "colors.violet.50": {
    "value": "#f5f3ff",
    "variable": "var(--colors-violet-50)"
  },
  "colors.violet.100": {
    "value": "#ede9fe",
    "variable": "var(--colors-violet-100)"
  },
  "colors.violet.200": {
    "value": "#ddd6fe",
    "variable": "var(--colors-violet-200)"
  },
  "colors.violet.300": {
    "value": "#c4b5fd",
    "variable": "var(--colors-violet-300)"
  },
  "colors.violet.400": {
    "value": "#a78bfa",
    "variable": "var(--colors-violet-400)"
  },
  "colors.violet.500": {
    "value": "#8b5cf6",
    "variable": "var(--colors-violet-500)"
  },
  "colors.violet.600": {
    "value": "#7c3aed",
    "variable": "var(--colors-violet-600)"
  },
  "colors.violet.700": {
    "value": "#6d28d9",
    "variable": "var(--colors-violet-700)"
  },
  "colors.violet.800": {
    "value": "#5b21b6",
    "variable": "var(--colors-violet-800)"
  },
  "colors.violet.900": {
    "value": "#4c1d95",
    "variable": "var(--colors-violet-900)"
  },
  "colors.violet.950": {
    "value": "#2e1065",
    "variable": "var(--colors-violet-950)"
  },
  "colors.indigo.50": {
    "value": "#eef2ff",
    "variable": "var(--colors-indigo-50)"
  },
  "colors.indigo.100": {
    "value": "#e0e7ff",
    "variable": "var(--colors-indigo-100)"
  },
  "colors.indigo.200": {
    "value": "#c7d2fe",
    "variable": "var(--colors-indigo-200)"
  },
  "colors.indigo.300": {
    "value": "#a5b4fc",
    "variable": "var(--colors-indigo-300)"
  },
  "colors.indigo.400": {
    "value": "#818cf8",
    "variable": "var(--colors-indigo-400)"
  },
  "colors.indigo.500": {
    "value": "#6366f1",
    "variable": "var(--colors-indigo-500)"
  },
  "colors.indigo.600": {
    "value": "#4f46e5",
    "variable": "var(--colors-indigo-600)"
  },
  "colors.indigo.700": {
    "value": "#4338ca",
    "variable": "var(--colors-indigo-700)"
  },
  "colors.indigo.800": {
    "value": "#3730a3",
    "variable": "var(--colors-indigo-800)"
  },
  "colors.indigo.900": {
    "value": "#312e81",
    "variable": "var(--colors-indigo-900)"
  },
  "colors.indigo.950": {
    "value": "#1e1b4b",
    "variable": "var(--colors-indigo-950)"
  },
  "colors.sky.50": {
    "value": "#f0f9ff",
    "variable": "var(--colors-sky-50)"
  },
  "colors.sky.100": {
    "value": "#e0f2fe",
    "variable": "var(--colors-sky-100)"
  },
  "colors.sky.200": {
    "value": "#bae6fd",
    "variable": "var(--colors-sky-200)"
  },
  "colors.sky.300": {
    "value": "#7dd3fc",
    "variable": "var(--colors-sky-300)"
  },
  "colors.sky.400": {
    "value": "#38bdf8",
    "variable": "var(--colors-sky-400)"
  },
  "colors.sky.500": {
    "value": "#0ea5e9",
    "variable": "var(--colors-sky-500)"
  },
  "colors.sky.600": {
    "value": "#0284c7",
    "variable": "var(--colors-sky-600)"
  },
  "colors.sky.700": {
    "value": "#0369a1",
    "variable": "var(--colors-sky-700)"
  },
  "colors.sky.800": {
    "value": "#075985",
    "variable": "var(--colors-sky-800)"
  },
  "colors.sky.900": {
    "value": "#0c4a6e",
    "variable": "var(--colors-sky-900)"
  },
  "colors.sky.950": {
    "value": "#082f49",
    "variable": "var(--colors-sky-950)"
  },
  "colors.emerald.50": {
    "value": "#ecfdf5",
    "variable": "var(--colors-emerald-50)"
  },
  "colors.emerald.100": {
    "value": "#d1fae5",
    "variable": "var(--colors-emerald-100)"
  },
  "colors.emerald.200": {
    "value": "#a7f3d0",
    "variable": "var(--colors-emerald-200)"
  },
  "colors.emerald.300": {
    "value": "#6ee7b7",
    "variable": "var(--colors-emerald-300)"
  },
  "colors.emerald.400": {
    "value": "#34d399",
    "variable": "var(--colors-emerald-400)"
  },
  "colors.emerald.500": {
    "value": "#10b981",
    "variable": "var(--colors-emerald-500)"
  },
  "colors.emerald.600": {
    "value": "#059669",
    "variable": "var(--colors-emerald-600)"
  },
  "colors.emerald.700": {
    "value": "#047857",
    "variable": "var(--colors-emerald-700)"
  },
  "colors.emerald.800": {
    "value": "#065f46",
    "variable": "var(--colors-emerald-800)"
  },
  "colors.emerald.900": {
    "value": "#064e3b",
    "variable": "var(--colors-emerald-900)"
  },
  "colors.emerald.950": {
    "value": "#022c22",
    "variable": "var(--colors-emerald-950)"
  },
  "colors.lime.50": {
    "value": "#f7fee7",
    "variable": "var(--colors-lime-50)"
  },
  "colors.lime.100": {
    "value": "#ecfccb",
    "variable": "var(--colors-lime-100)"
  },
  "colors.lime.200": {
    "value": "#d9f99d",
    "variable": "var(--colors-lime-200)"
  },
  "colors.lime.300": {
    "value": "#bef264",
    "variable": "var(--colors-lime-300)"
  },
  "colors.lime.400": {
    "value": "#a3e635",
    "variable": "var(--colors-lime-400)"
  },
  "colors.lime.500": {
    "value": "#84cc16",
    "variable": "var(--colors-lime-500)"
  },
  "colors.lime.600": {
    "value": "#65a30d",
    "variable": "var(--colors-lime-600)"
  },
  "colors.lime.700": {
    "value": "#4d7c0f",
    "variable": "var(--colors-lime-700)"
  },
  "colors.lime.800": {
    "value": "#3f6212",
    "variable": "var(--colors-lime-800)"
  },
  "colors.lime.900": {
    "value": "#365314",
    "variable": "var(--colors-lime-900)"
  },
  "colors.lime.950": {
    "value": "#1a2e05",
    "variable": "var(--colors-lime-950)"
  },
  "colors.amber.50": {
    "value": "#fffbeb",
    "variable": "var(--colors-amber-50)"
  },
  "colors.amber.100": {
    "value": "#fef3c7",
    "variable": "var(--colors-amber-100)"
  },
  "colors.amber.200": {
    "value": "#fde68a",
    "variable": "var(--colors-amber-200)"
  },
  "colors.amber.300": {
    "value": "#fcd34d",
    "variable": "var(--colors-amber-300)"
  },
  "colors.amber.400": {
    "value": "#fbbf24",
    "variable": "var(--colors-amber-400)"
  },
  "colors.amber.500": {
    "value": "#f59e0b",
    "variable": "var(--colors-amber-500)"
  },
  "colors.amber.600": {
    "value": "#d97706",
    "variable": "var(--colors-amber-600)"
  },
  "colors.amber.700": {
    "value": "#b45309",
    "variable": "var(--colors-amber-700)"
  },
  "colors.amber.800": {
    "value": "#92400e",
    "variable": "var(--colors-amber-800)"
  },
  "colors.amber.900": {
    "value": "#78350f",
    "variable": "var(--colors-amber-900)"
  },
  "colors.amber.950": {
    "value": "#451a03",
    "variable": "var(--colors-amber-950)"
  },
  "colors.neutral.50": {
    "value": "#fafafa",
    "variable": "var(--colors-neutral-50)"
  },
  "colors.neutral.100": {
    "value": "#f5f5f5",
    "variable": "var(--colors-neutral-100)"
  },
  "colors.neutral.200": {
    "value": "#e5e5e5",
    "variable": "var(--colors-neutral-200)"
  },
  "colors.neutral.300": {
    "value": "#d4d4d4",
    "variable": "var(--colors-neutral-300)"
  },
  "colors.neutral.400": {
    "value": "#a3a3a3",
    "variable": "var(--colors-neutral-400)"
  },
  "colors.neutral.500": {
    "value": "#737373",
    "variable": "var(--colors-neutral-500)"
  },
  "colors.neutral.600": {
    "value": "#525252",
    "variable": "var(--colors-neutral-600)"
  },
  "colors.neutral.700": {
    "value": "#404040",
    "variable": "var(--colors-neutral-700)"
  },
  "colors.neutral.800": {
    "value": "#262626",
    "variable": "var(--colors-neutral-800)"
  },
  "colors.neutral.900": {
    "value": "#171717",
    "variable": "var(--colors-neutral-900)"
  },
  "colors.neutral.950": {
    "value": "#0a0a0a",
    "variable": "var(--colors-neutral-950)"
  },
  "colors.stone.50": {
    "value": "#fafaf9",
    "variable": "var(--colors-stone-50)"
  },
  "colors.stone.100": {
    "value": "#f5f5f4",
    "variable": "var(--colors-stone-100)"
  },
  "colors.stone.200": {
    "value": "#e7e5e4",
    "variable": "var(--colors-stone-200)"
  },
  "colors.stone.300": {
    "value": "#d6d3d1",
    "variable": "var(--colors-stone-300)"
  },
  "colors.stone.400": {
    "value": "#a8a29e",
    "variable": "var(--colors-stone-400)"
  },
  "colors.stone.500": {
    "value": "#78716c",
    "variable": "var(--colors-stone-500)"
  },
  "colors.stone.600": {
    "value": "#57534e",
    "variable": "var(--colors-stone-600)"
  },
  "colors.stone.700": {
    "value": "#44403c",
    "variable": "var(--colors-stone-700)"
  },
  "colors.stone.800": {
    "value": "#292524",
    "variable": "var(--colors-stone-800)"
  },
  "colors.stone.900": {
    "value": "#1c1917",
    "variable": "var(--colors-stone-900)"
  },
  "colors.stone.950": {
    "value": "#0c0a09",
    "variable": "var(--colors-stone-950)"
  },
  "colors.zinc.50": {
    "value": "#fafafa",
    "variable": "var(--colors-zinc-50)"
  },
  "colors.zinc.100": {
    "value": "#f4f4f5",
    "variable": "var(--colors-zinc-100)"
  },
  "colors.zinc.200": {
    "value": "#e4e4e7",
    "variable": "var(--colors-zinc-200)"
  },
  "colors.zinc.300": {
    "value": "#d4d4d8",
    "variable": "var(--colors-zinc-300)"
  },
  "colors.zinc.400": {
    "value": "#a1a1aa",
    "variable": "var(--colors-zinc-400)"
  },
  "colors.zinc.500": {
    "value": "#71717a",
    "variable": "var(--colors-zinc-500)"
  },
  "colors.zinc.600": {
    "value": "#52525b",
    "variable": "var(--colors-zinc-600)"
  },
  "colors.zinc.700": {
    "value": "#3f3f46",
    "variable": "var(--colors-zinc-700)"
  },
  "colors.zinc.800": {
    "value": "#27272a",
    "variable": "var(--colors-zinc-800)"
  },
  "colors.zinc.900": {
    "value": "#18181b",
    "variable": "var(--colors-zinc-900)"
  },
  "colors.zinc.950": {
    "value": "#09090b",
    "variable": "var(--colors-zinc-950)"
  },
  "colors.slate.50": {
    "value": "#f8fafc",
    "variable": "var(--colors-slate-50)"
  },
  "colors.slate.100": {
    "value": "#f1f5f9",
    "variable": "var(--colors-slate-100)"
  },
  "colors.slate.200": {
    "value": "#e2e8f0",
    "variable": "var(--colors-slate-200)"
  },
  "colors.slate.300": {
    "value": "#cbd5e1",
    "variable": "var(--colors-slate-300)"
  },
  "colors.slate.400": {
    "value": "#94a3b8",
    "variable": "var(--colors-slate-400)"
  },
  "colors.slate.500": {
    "value": "#64748b",
    "variable": "var(--colors-slate-500)"
  },
  "colors.slate.600": {
    "value": "#475569",
    "variable": "var(--colors-slate-600)"
  },
  "colors.slate.700": {
    "value": "#334155",
    "variable": "var(--colors-slate-700)"
  },
  "colors.slate.800": {
    "value": "#1e293b",
    "variable": "var(--colors-slate-800)"
  },
  "colors.slate.900": {
    "value": "#0f172a",
    "variable": "var(--colors-slate-900)"
  },
  "colors.slate.950": {
    "value": "#020617",
    "variable": "var(--colors-slate-950)"
  },
  "colors.transparent": {
    "value": "transparent",
    "variable": "var(--colors-transparent)"
  },
  "colors.current": {
    "value": "currentColor",
    "variable": "var(--colors-current)"
  },
  "colors.black": {
    "value": "#000000",
    "variable": "var(--colors-black)"
  },
  "colors.white": {
    "value": "#FFFFFF",
    "variable": "var(--colors-white)"
  },
  "colors.whiteAlpha.50": {
    "value": "rgba(255, 255, 255, 0.04)",
    "variable": "var(--colors-white-alpha-50)"
  },
  "colors.whiteAlpha.100": {
    "value": "rgba(255, 255, 255, 0.06)",
    "variable": "var(--colors-white-alpha-100)"
  },
  "colors.whiteAlpha.200": {
    "value": "rgba(255, 255, 255, 0.08)",
    "variable": "var(--colors-white-alpha-200)"
  },
  "colors.whiteAlpha.300": {
    "value": "rgba(255, 255, 255, 0.16)",
    "variable": "var(--colors-white-alpha-300)"
  },
  "colors.whiteAlpha.400": {
    "value": "rgba(255, 255, 255, 0.24)",
    "variable": "var(--colors-white-alpha-400)"
  },
  "colors.whiteAlpha.500": {
    "value": "rgba(255, 255, 255, 0.36)",
    "variable": "var(--colors-white-alpha-500)"
  },
  "colors.whiteAlpha.600": {
    "value": "rgba(255, 255, 255, 0.48)",
    "variable": "var(--colors-white-alpha-600)"
  },
  "colors.whiteAlpha.700": {
    "value": "rgba(255, 255, 255, 0.64)",
    "variable": "var(--colors-white-alpha-700)"
  },
  "colors.whiteAlpha.800": {
    "value": "rgba(255, 255, 255, 0.80)",
    "variable": "var(--colors-white-alpha-800)"
  },
  "colors.whiteAlpha.900": {
    "value": "rgba(255, 255, 255, 0.92)",
    "variable": "var(--colors-white-alpha-900)"
  },
  "colors.blackAlpha.50": {
    "value": "rgba(0, 0, 0, 0.04)",
    "variable": "var(--colors-black-alpha-50)"
  },
  "colors.blackAlpha.100": {
    "value": "rgba(0, 0, 0, 0.06)",
    "variable": "var(--colors-black-alpha-100)"
  },
  "colors.blackAlpha.200": {
    "value": "rgba(0, 0, 0, 0.08)",
    "variable": "var(--colors-black-alpha-200)"
  },
  "colors.blackAlpha.300": {
    "value": "rgba(0, 0, 0, 0.16)",
    "variable": "var(--colors-black-alpha-300)"
  },
  "colors.blackAlpha.400": {
    "value": "rgba(0, 0, 0, 0.24)",
    "variable": "var(--colors-black-alpha-400)"
  },
  "colors.blackAlpha.500": {
    "value": "rgba(0, 0, 0, 0.36)",
    "variable": "var(--colors-black-alpha-500)"
  },
  "colors.blackAlpha.600": {
    "value": "rgba(0, 0, 0, 0.48)",
    "variable": "var(--colors-black-alpha-600)"
  },
  "colors.blackAlpha.700": {
    "value": "rgba(0, 0, 0, 0.64)",
    "variable": "var(--colors-black-alpha-700)"
  },
  "colors.blackAlpha.800": {
    "value": "rgba(0, 0, 0, 0.80)",
    "variable": "var(--colors-black-alpha-800)"
  },
  "colors.blackAlpha.900": {
    "value": "rgba(0, 0, 0, 0.92)",
    "variable": "var(--colors-black-alpha-900)"
  },
  "colors.gray.50": {
    "value": "#F7FAFC",
    "variable": "var(--colors-gray-50)"
  },
  "colors.gray.100": {
    "value": "#EDF2F7",
    "variable": "var(--colors-gray-100)"
  },
  "colors.gray.200": {
    "value": "#E2E8F0",
    "variable": "var(--colors-gray-200)"
  },
  "colors.gray.300": {
    "value": "#CBD5E0",
    "variable": "var(--colors-gray-300)"
  },
  "colors.gray.400": {
    "value": "#A0AEC0",
    "variable": "var(--colors-gray-400)"
  },
  "colors.gray.500": {
    "value": "#718096",
    "variable": "var(--colors-gray-500)"
  },
  "colors.gray.600": {
    "value": "#4A5568",
    "variable": "var(--colors-gray-600)"
  },
  "colors.gray.700": {
    "value": "#2D3748",
    "variable": "var(--colors-gray-700)"
  },
  "colors.gray.800": {
    "value": "#1A202C",
    "variable": "var(--colors-gray-800)"
  },
  "colors.gray.900": {
    "value": "#171923",
    "variable": "var(--colors-gray-900)"
  },
  "colors.gray.950": {
    "value": "#030712",
    "variable": "var(--colors-gray-950)"
  },
  "colors.red.50": {
    "value": "#FFF5F5",
    "variable": "var(--colors-red-50)"
  },
  "colors.red.100": {
    "value": "#FED7D7",
    "variable": "var(--colors-red-100)"
  },
  "colors.red.200": {
    "value": "#FEB2B2",
    "variable": "var(--colors-red-200)"
  },
  "colors.red.300": {
    "value": "#FC8181",
    "variable": "var(--colors-red-300)"
  },
  "colors.red.400": {
    "value": "#F56565",
    "variable": "var(--colors-red-400)"
  },
  "colors.red.500": {
    "value": "#E53E3E",
    "variable": "var(--colors-red-500)"
  },
  "colors.red.600": {
    "value": "#C53030",
    "variable": "var(--colors-red-600)"
  },
  "colors.red.700": {
    "value": "#9B2C2C",
    "variable": "var(--colors-red-700)"
  },
  "colors.red.800": {
    "value": "#822727",
    "variable": "var(--colors-red-800)"
  },
  "colors.red.900": {
    "value": "#63171B",
    "variable": "var(--colors-red-900)"
  },
  "colors.red.950": {
    "value": "#450a0a",
    "variable": "var(--colors-red-950)"
  },
  "colors.orange.50": {
    "value": "#FFFAF0",
    "variable": "var(--colors-orange-50)"
  },
  "colors.orange.100": {
    "value": "#FEEBC8",
    "variable": "var(--colors-orange-100)"
  },
  "colors.orange.200": {
    "value": "#FBD38D",
    "variable": "var(--colors-orange-200)"
  },
  "colors.orange.300": {
    "value": "#F6AD55",
    "variable": "var(--colors-orange-300)"
  },
  "colors.orange.400": {
    "value": "#ED8936",
    "variable": "var(--colors-orange-400)"
  },
  "colors.orange.500": {
    "value": "#DD6B20",
    "variable": "var(--colors-orange-500)"
  },
  "colors.orange.600": {
    "value": "#C05621",
    "variable": "var(--colors-orange-600)"
  },
  "colors.orange.700": {
    "value": "#9C4221",
    "variable": "var(--colors-orange-700)"
  },
  "colors.orange.800": {
    "value": "#7B341E",
    "variable": "var(--colors-orange-800)"
  },
  "colors.orange.900": {
    "value": "#652B19",
    "variable": "var(--colors-orange-900)"
  },
  "colors.orange.950": {
    "value": "#431407",
    "variable": "var(--colors-orange-950)"
  },
  "colors.yellow.50": {
    "value": "#FFFFF0",
    "variable": "var(--colors-yellow-50)"
  },
  "colors.yellow.100": {
    "value": "#FEFCBF",
    "variable": "var(--colors-yellow-100)"
  },
  "colors.yellow.200": {
    "value": "#FAF089",
    "variable": "var(--colors-yellow-200)"
  },
  "colors.yellow.300": {
    "value": "#F6E05E",
    "variable": "var(--colors-yellow-300)"
  },
  "colors.yellow.400": {
    "value": "#ECC94B",
    "variable": "var(--colors-yellow-400)"
  },
  "colors.yellow.500": {
    "value": "#D69E2E",
    "variable": "var(--colors-yellow-500)"
  },
  "colors.yellow.600": {
    "value": "#B7791F",
    "variable": "var(--colors-yellow-600)"
  },
  "colors.yellow.700": {
    "value": "#975A16",
    "variable": "var(--colors-yellow-700)"
  },
  "colors.yellow.800": {
    "value": "#744210",
    "variable": "var(--colors-yellow-800)"
  },
  "colors.yellow.900": {
    "value": "#5F370E",
    "variable": "var(--colors-yellow-900)"
  },
  "colors.yellow.950": {
    "value": "#422006",
    "variable": "var(--colors-yellow-950)"
  },
  "colors.green.50": {
    "value": "#F0FFF4",
    "variable": "var(--colors-green-50)"
  },
  "colors.green.100": {
    "value": "#C6F6D5",
    "variable": "var(--colors-green-100)"
  },
  "colors.green.200": {
    "value": "#9AE6B4",
    "variable": "var(--colors-green-200)"
  },
  "colors.green.300": {
    "value": "#68D391",
    "variable": "var(--colors-green-300)"
  },
  "colors.green.400": {
    "value": "#48BB78",
    "variable": "var(--colors-green-400)"
  },
  "colors.green.500": {
    "value": "#38A169",
    "variable": "var(--colors-green-500)"
  },
  "colors.green.600": {
    "value": "#2F855A",
    "variable": "var(--colors-green-600)"
  },
  "colors.green.700": {
    "value": "#276749",
    "variable": "var(--colors-green-700)"
  },
  "colors.green.800": {
    "value": "#22543D",
    "variable": "var(--colors-green-800)"
  },
  "colors.green.900": {
    "value": "#1C4532",
    "variable": "var(--colors-green-900)"
  },
  "colors.green.950": {
    "value": "#052e16",
    "variable": "var(--colors-green-950)"
  },
  "colors.teal.50": {
    "value": "#E6FFFA",
    "variable": "var(--colors-teal-50)"
  },
  "colors.teal.100": {
    "value": "#B2F5EA",
    "variable": "var(--colors-teal-100)"
  },
  "colors.teal.200": {
    "value": "#81E6D9",
    "variable": "var(--colors-teal-200)"
  },
  "colors.teal.300": {
    "value": "#4FD1C5",
    "variable": "var(--colors-teal-300)"
  },
  "colors.teal.400": {
    "value": "#38B2AC",
    "variable": "var(--colors-teal-400)"
  },
  "colors.teal.500": {
    "value": "#319795",
    "variable": "var(--colors-teal-500)"
  },
  "colors.teal.600": {
    "value": "#2C7A7B",
    "variable": "var(--colors-teal-600)"
  },
  "colors.teal.700": {
    "value": "#285E61",
    "variable": "var(--colors-teal-700)"
  },
  "colors.teal.800": {
    "value": "#234E52",
    "variable": "var(--colors-teal-800)"
  },
  "colors.teal.900": {
    "value": "#1D4044",
    "variable": "var(--colors-teal-900)"
  },
  "colors.teal.950": {
    "value": "#042f2e",
    "variable": "var(--colors-teal-950)"
  },
  "colors.blue.50": {
    "value": "#ebf8ff",
    "variable": "var(--colors-blue-50)"
  },
  "colors.blue.100": {
    "value": "#bee3f8",
    "variable": "var(--colors-blue-100)"
  },
  "colors.blue.200": {
    "value": "#90cdf4",
    "variable": "var(--colors-blue-200)"
  },
  "colors.blue.300": {
    "value": "#63b3ed",
    "variable": "var(--colors-blue-300)"
  },
  "colors.blue.400": {
    "value": "#4299e1",
    "variable": "var(--colors-blue-400)"
  },
  "colors.blue.500": {
    "value": "#3182ce",
    "variable": "var(--colors-blue-500)"
  },
  "colors.blue.600": {
    "value": "#2b6cb0",
    "variable": "var(--colors-blue-600)"
  },
  "colors.blue.700": {
    "value": "#2c5282",
    "variable": "var(--colors-blue-700)"
  },
  "colors.blue.800": {
    "value": "#2a4365",
    "variable": "var(--colors-blue-800)"
  },
  "colors.blue.900": {
    "value": "#1A365D",
    "variable": "var(--colors-blue-900)"
  },
  "colors.blue.950": {
    "value": "#172554",
    "variable": "var(--colors-blue-950)"
  },
  "colors.cyan.50": {
    "value": "#EDFDFD",
    "variable": "var(--colors-cyan-50)"
  },
  "colors.cyan.100": {
    "value": "#C4F1F9",
    "variable": "var(--colors-cyan-100)"
  },
  "colors.cyan.200": {
    "value": "#9DECF9",
    "variable": "var(--colors-cyan-200)"
  },
  "colors.cyan.300": {
    "value": "#76E4F7",
    "variable": "var(--colors-cyan-300)"
  },
  "colors.cyan.400": {
    "value": "#0BC5EA",
    "variable": "var(--colors-cyan-400)"
  },
  "colors.cyan.500": {
    "value": "#00B5D8",
    "variable": "var(--colors-cyan-500)"
  },
  "colors.cyan.600": {
    "value": "#00A3C4",
    "variable": "var(--colors-cyan-600)"
  },
  "colors.cyan.700": {
    "value": "#0987A0",
    "variable": "var(--colors-cyan-700)"
  },
  "colors.cyan.800": {
    "value": "#086F83",
    "variable": "var(--colors-cyan-800)"
  },
  "colors.cyan.900": {
    "value": "#065666",
    "variable": "var(--colors-cyan-900)"
  },
  "colors.cyan.950": {
    "value": "#083344",
    "variable": "var(--colors-cyan-950)"
  },
  "colors.purple.50": {
    "value": "#FAF5FF",
    "variable": "var(--colors-purple-50)"
  },
  "colors.purple.100": {
    "value": "#E9D8FD",
    "variable": "var(--colors-purple-100)"
  },
  "colors.purple.200": {
    "value": "#D6BCFA",
    "variable": "var(--colors-purple-200)"
  },
  "colors.purple.300": {
    "value": "#B794F4",
    "variable": "var(--colors-purple-300)"
  },
  "colors.purple.400": {
    "value": "#9F7AEA",
    "variable": "var(--colors-purple-400)"
  },
  "colors.purple.500": {
    "value": "#805AD5",
    "variable": "var(--colors-purple-500)"
  },
  "colors.purple.600": {
    "value": "#6B46C1",
    "variable": "var(--colors-purple-600)"
  },
  "colors.purple.700": {
    "value": "#553C9A",
    "variable": "var(--colors-purple-700)"
  },
  "colors.purple.800": {
    "value": "#44337A",
    "variable": "var(--colors-purple-800)"
  },
  "colors.purple.900": {
    "value": "#322659",
    "variable": "var(--colors-purple-900)"
  },
  "colors.purple.950": {
    "value": "#3b0764",
    "variable": "var(--colors-purple-950)"
  },
  "colors.pink.50": {
    "value": "#FFF5F7",
    "variable": "var(--colors-pink-50)"
  },
  "colors.pink.100": {
    "value": "#FED7E2",
    "variable": "var(--colors-pink-100)"
  },
  "colors.pink.200": {
    "value": "#FBB6CE",
    "variable": "var(--colors-pink-200)"
  },
  "colors.pink.300": {
    "value": "#F687B3",
    "variable": "var(--colors-pink-300)"
  },
  "colors.pink.400": {
    "value": "#ED64A6",
    "variable": "var(--colors-pink-400)"
  },
  "colors.pink.500": {
    "value": "#D53F8C",
    "variable": "var(--colors-pink-500)"
  },
  "colors.pink.600": {
    "value": "#B83280",
    "variable": "var(--colors-pink-600)"
  },
  "colors.pink.700": {
    "value": "#97266D",
    "variable": "var(--colors-pink-700)"
  },
  "colors.pink.800": {
    "value": "#702459",
    "variable": "var(--colors-pink-800)"
  },
  "colors.pink.900": {
    "value": "#521B41",
    "variable": "var(--colors-pink-900)"
  },
  "colors.pink.950": {
    "value": "#500724",
    "variable": "var(--colors-pink-950)"
  },
  "colors.brand.primary": {
    "value": "#623875",
    "variable": "var(--colors-brand-primary)"
  },
  "colors.brand.secondary": {
    "value": "#b4b6c1",
    "variable": "var(--colors-brand-secondary)"
  },
  "colors.primary.100": {
    "value": "#cec1d4",
    "variable": "var(--colors-primary-100)"
  },
  "colors.primary.300": {
    "value": "#cec1d4",
    "variable": "var(--colors-primary-300)"
  },
  "colors.primary.500": {
    "value": "#623875",
    "variable": "var(--colors-primary-500)"
  },
  "colors.primary.600": {
    "value": "#462853",
    "variable": "var(--colors-primary-600)"
  },
  "colors.primary.main": {
    "value": "#623875",
    "variable": "var(--colors-primary-main)"
  },
  "colors.primary.light": {
    "value": "#cec1d4",
    "variable": "var(--colors-primary-light)"
  },
  "colors.primary.dark": {
    "value": "#462853",
    "variable": "var(--colors-primary-dark)"
  },
  "colors.greys.50": {
    "value": "#f4f4f6",
    "variable": "var(--colors-greys-50)"
  },
  "colors.greys.100": {
    "value": "#e7e8eb",
    "variable": "var(--colors-greys-100)"
  },
  "colors.greys.200": {
    "value": "#b4b6c1",
    "variable": "var(--colors-greys-200)"
  },
  "colors.greys.300": {
    "value": "#8f93a3",
    "variable": "var(--colors-greys-300)"
  },
  "colors.greys.400": {
    "value": "#5c6278",
    "variable": "var(--colors-greys-400)"
  },
  "colors.greys.500": {
    "value": "#3d435e",
    "variable": "var(--colors-greys-500)"
  },
  "colors.greys.600": {
    "value": "#0c1436",
    "variable": "var(--colors-greys-600)"
  },
  "colors.greys.700": {
    "value": "#0b1231",
    "variable": "var(--colors-greys-700)"
  },
  "colors.greys.white": {
    "value": "#ffffff",
    "variable": "var(--colors-greys-white)"
  },
  "colors.secondary.50": {
    "value": "#f4f4f6",
    "variable": "var(--colors-secondary-50)"
  },
  "colors.secondary.100": {
    "value": "#e7e8eb",
    "variable": "var(--colors-secondary-100)"
  },
  "colors.secondary.200": {
    "value": "#b4b6c1",
    "variable": "var(--colors-secondary-200)"
  },
  "colors.secondary.300": {
    "value": "#8f93a3",
    "variable": "var(--colors-secondary-300)"
  },
  "colors.secondary.400": {
    "value": "#5c6278",
    "variable": "var(--colors-secondary-400)"
  },
  "colors.secondary.500": {
    "value": "#3d435e",
    "variable": "var(--colors-secondary-500)"
  },
  "colors.secondary.600": {
    "value": "#0c1436",
    "variable": "var(--colors-secondary-600)"
  },
  "colors.secondary.700": {
    "value": "#0b1231",
    "variable": "var(--colors-secondary-700)"
  },
  "colors.secondary.white": {
    "value": "#ffffff",
    "variable": "var(--colors-secondary-white)"
  },
  "colors.danger.400": {
    "value": "#ffc1cc",
    "variable": "var(--colors-danger-400)"
  },
  "colors.danger.500": {
    "value": "#ff375b",
    "variable": "var(--colors-danger-500)"
  },
  "colors.danger.600": {
    "value": "#b52741",
    "variable": "var(--colors-danger-600)"
  },
  "colors.other.informationFocus": {
    "value": "#0671e0",
    "variable": "var(--colors-other-information-focus)"
  },
  "colors.other.dividerStroke": {
    "value": "#b4b6c1",
    "variable": "var(--colors-other-divider-stroke)"
  },
  "colors.other.glassStroke": {
    "value": "#ffffff",
    "variable": "var(--colors-other-glass-stroke)"
  },
  "colors.productAccent.contactCentreLight": {
    "value": "#dbacf5",
    "variable": "var(--colors-product-accent-contact-centre-light)"
  },
  "colors.productAccent.virtualAgentsMain": {
    "value": "#0f78c7",
    "variable": "var(--colors-product-accent-virtual-agents-main)"
  },
  "colors.productAccent.virtualAgentsLight": {
    "value": "#60ade7",
    "variable": "var(--colors-product-accent-virtual-agents-light)"
  },
  "colors.productAccent.conversationIntelligenceMain": {
    "value": "#ff9903",
    "variable": "var(--colors-product-accent-conversation-intelligence-main)"
  },
  "colors.productAccent.conversationIntelligenceLight": {
    "value": "#fff3eb",
    "variable": "var(--colors-product-accent-conversation-intelligence-light)"
  },
  "colors.productAccent.workforceManagementMain": {
    "value": "#00c06a",
    "variable": "var(--colors-product-accent-workforce-management-main)"
  },
  "colors.productAccent.workforceManagementLight": {
    "value": "#b0ebd1",
    "variable": "var(--colors-product-accent-workforce-management-light)"
  },
  "colors.productAccent.caseManagementMain": {
    "value": "#c79ddf",
    "variable": "var(--colors-product-accent-case-management-main)"
  },
  "colors.productAccent.caseManagementLight": {
    "value": "#f4e5fc",
    "variable": "var(--colors-product-accent-case-management-light)"
  },
  "colors.productAccent.agentCopilotMain": {
    "value": "#33c4b3",
    "variable": "var(--colors-product-accent-agent-copilot-main)"
  },
  "colors.productAccent.agentCopilotLight": {
    "value": "#c0ede7",
    "variable": "var(--colors-product-accent-agent-copilot-light)"
  },
  "colors.graph.primary.300": {
    "value": "#2b8ec4",
    "variable": "var(--colors-graph-primary-300)"
  },
  "colors.graph.primary.500": {
    "value": "#216d97",
    "variable": "var(--colors-graph-primary-500)"
  },
  "colors.graph.primary.600": {
    "value": "#1a5779",
    "variable": "var(--colors-graph-primary-600)"
  },
  "colors.graph.secondary.300": {
    "value": "#ffc704",
    "variable": "var(--colors-graph-secondary-300)"
  },
  "colors.graph.secondary.500": {
    "value": "#ff9903",
    "variable": "var(--colors-graph-secondary-500)"
  },
  "colors.graph.secondary.600": {
    "value": "#cc7a02",
    "variable": "var(--colors-graph-secondary-600)"
  },
  "colors.graph.tertiary.300": {
    "value": "#6dbeb1",
    "variable": "var(--colors-graph-tertiary-300)"
  },
  "colors.graph.tertiary.500": {
    "value": "#549288",
    "variable": "var(--colors-graph-tertiary-500)"
  },
  "colors.graph.tertiary.600": {
    "value": "#43756d",
    "variable": "var(--colors-graph-tertiary-600)"
  },
  "colors.graph.quarternary.300": {
    "value": "#ffe0ff",
    "variable": "var(--colors-graph-quarternary-300)"
  },
  "colors.graph.quarternary.500": {
    "value": "#dbacf5",
    "variable": "var(--colors-graph-quarternary-500)"
  },
  "colors.graph.quarternary.600": {
    "value": "#af8ac4",
    "variable": "var(--colors-graph-quarternary-600)"
  },
  "colors.graph.quinary.300": {
    "value": "#ff4876",
    "variable": "var(--colors-graph-quinary-300)"
  },
  "colors.graph.quinary.500": {
    "value": "#ff375b",
    "variable": "var(--colors-graph-quinary-500)"
  },
  "colors.graph.quinary.600": {
    "value": "#cc2c49",
    "variable": "var(--colors-graph-quinary-600)"
  },
  "colors.graph.senary.300": {
    "value": "#ffb504",
    "variable": "var(--colors-graph-senary-300)"
  },
  "colors.graph.senary.500": {
    "value": "#e88b03",
    "variable": "var(--colors-graph-senary-500)"
  },
  "colors.graph.senary.600": {
    "value": "#ba6f02",
    "variable": "var(--colors-graph-senary-600)"
  },
  "colors.graph.septenary.300": {
    "value": "#d1000e",
    "variable": "var(--colors-graph-septenary-300)"
  },
  "colors.graph.septenary.500": {
    "value": "#a1000b",
    "variable": "var(--colors-graph-septenary-500)"
  },
  "colors.graph.septenary.600": {
    "value": "#810009",
    "variable": "var(--colors-graph-septenary-600)"
  },
  "colors.graph.octonary.300": {
    "value": "#101a46",
    "variable": "var(--colors-graph-octonary-300)"
  },
  "colors.graph.octonary.500": {
    "value": "#0c1436",
    "variable": "var(--colors-graph-octonary-500)"
  },
  "colors.graph.octonary.600": {
    "value": "#0a102b",
    "variable": "var(--colors-graph-octonary-600)"
  },
  "colors.graph.nonary.300": {
    "value": "#ebe1d9",
    "variable": "var(--colors-graph-nonary-300)"
  },
  "colors.graph.nonary.500": {
    "value": "#b5ada7",
    "variable": "var(--colors-graph-nonary-500)"
  },
  "colors.graph.nonary.600": {
    "value": "#918a86",
    "variable": "var(--colors-graph-nonary-600)"
  },
  "colors.graph.denary.300": {
    "value": "#b66d03",
    "variable": "var(--colors-graph-denary-300)"
  },
  "colors.graph.denary.500": {
    "value": "#8c5402",
    "variable": "var(--colors-graph-denary-500)"
  },
  "colors.graph.denary.600": {
    "value": "#704302",
    "variable": "var(--colors-graph-denary-600)"
  },
  "colors.signal.success": {
    "value": "#33c4b3",
    "variable": "var(--colors-signal-success)"
  },
  "colors.signal.dangerError": {
    "value": "#ff375b",
    "variable": "var(--colors-signal-danger-error)"
  },
  "colors.signal.positive": {
    "value": "#00884b",
    "variable": "var(--colors-signal-positive)"
  },
  "colors.signal.negative": {
    "value": "#B52741",
    "variable": "var(--colors-signal-negative)"
  },
  "colors.signal.caution": {
    "value": "#ff9903",
    "variable": "var(--colors-signal-caution)"
  },
  "colors.signal.cautionLight": {
    "value": "#ffdfb1",
    "variable": "var(--colors-signal-caution-light)"
  },
  "colors.signal.cautionDark": {
    "value": "#b56d02",
    "variable": "var(--colors-signal-caution-dark)"
  },
  "colors.signal.dangerErrorLight": {
    "value": "#ffc1cc",
    "variable": "var(--colors-signal-danger-error-light)"
  },
  "colors.signal.dangerErrorDark": {
    "value": "#b52741",
    "variable": "var(--colors-signal-danger-error-dark)"
  },
  "colors.signal.successLight": {
    "value": "#c0ede7",
    "variable": "var(--colors-signal-success-light)"
  },
  "colors.signal.successDark": {
    "value": "#248b7f",
    "variable": "var(--colors-signal-success-dark)"
  },
  "colors.widgetBackground.blue": {
    "value": "#e7f3fb",
    "variable": "var(--colors-widget-background-blue)"
  },
  "colors.widgetBackground.sand": {
    "value": "#e7e8eb",
    "variable": "var(--colors-widget-background-sand)"
  },
  "colors.widgetBackground.green": {
    "value": "#C0EDE7",
    "variable": "var(--colors-widget-background-green)"
  },
  "colors.widgetBackground.yellow": {
    "value": "#FFDFB1",
    "variable": "var(--colors-widget-background-yellow)"
  },
  "colors.widgetBackground.red": {
    "value": "#FFC1CC",
    "variable": "var(--colors-widget-background-red)"
  },
  "colors.productgradients.conversationalintelligence": {
    "value": "linear-gradient(0deg, rgba(255, 255, 255, 0.85) 0%, rgba(255, 255, 255, 0.85) 100%), radial-gradient(92.76% 73.33% at -2% -4.67%, rgba(255, 153, 3, 0.40) 0%, rgba(255, 153, 3, 0.00) 100%), radial-gradient(173.95% 133.06% at 110% 111.33%, rgba(255, 153, 3, 0.30) 0%, rgba(255, 153, 3, 0.00) 100%), #FFF",
    "variable": "var(--colors-productgradients-conversationalintelligence)"
  },
  "colors.productgradients.virtualAgents": {
    "value": "linear-gradient(0deg, rgba(255, 255, 255, 0.85) 0%, rgba(255, 255, 255, 0.85) 100%), radial-gradient(92.76% 73.33% at -2% -4.67%, #0F78C7 0%, rgba(15, 120, 199, 0.00) 100%), radial-gradient(173.95% 133.06% at 110% 111.33%, rgba(96, 173, 231, 0.90) 0%, rgba(96, 173, 231, 0.00) 100%), linear-gradient(0deg, #B5D9F4 0%, #60ADE7 66%)",
    "variable": "var(--colors-productgradients-virtual-agents)"
  },
  "colors.gradients.aiGradientWeak": {
    "value": "linear-gradient(260deg, rgba(255, 153, 3, 0.00) 23.47%, rgba(255, 55, 91, 0.06) 47.05%, rgba(51, 196, 179, 0.00) 78.99%), linear-gradient(293deg, rgba(255, 55, 91, 0.00) 17.32%, rgba(255, 153, 3, 0.03) 48.33%, rgba(51, 196, 179, 0.06) 61.28%, rgba(51, 196, 179, 0.00) 85.76%), linear-gradient(270deg, #FFF 0%, #FAFAFA 100%)",
    "variable": "var(--colors-gradients-ai-gradient-weak)"
  },
  "colors.gradients.aiGradientStrong": {
    "value": "linear-gradient(0deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.25) 100%), linear-gradient(180deg, rgba(255, 255, 255, 0.00) 43.85%, rgba(255, 255, 255, 0.75) 100%), radial-gradient(41.08% 58.46% at 50.27% 0%, rgba(255, 153, 3, 0.25) 0%, rgba(255, 153, 3, 0.00) 100%), radial-gradient(85.91% 84.32% at 0% 0%, rgba(51, 196, 179, 0.50) 0%, rgba(51, 196, 179, 0.00) 100%), radial-gradient(112.44% 70.52% at 100% 0%, rgba(219, 172, 245, 0.75) 0%, rgba(219, 172, 245, 0.00) 100%), #F4E5FC",
    "variable": "var(--colors-gradients-ai-gradient-strong)"
  },
  "colors.gradients.aiStrokeText": {
    "value": "linear-gradient(0deg, #ff9cac 0%, #fecc82 49%, #9ce2d8 100%)",
    "variable": "var(--colors-gradients-ai-stroke-text)"
  },
  "colors.gradients.dark": {
    "value": "linear-gradient(0deg, rgba(98, 56, 117, 0.50) 0%, rgba(98, 56, 117, 0.50) 100%), radial-gradient(109.42% 85.6% at -2% -4.67%, rgba(51, 196, 179, 0.75) 0%, rgba(51, 196, 179, 0.00) 100%), radial-gradient(167.07% 153.23% at 130.67% 154.67%, rgba(255, 153, 3, 0.50) 0.19%, rgba(255, 153, 3, 0.25) 65%, rgba(255, 153, 3, 0.00) 100%), linear-gradient(91deg, #462853 0%, #623875 35%, #C79DDF 100%)",
    "variable": "var(--colors-gradients-dark)"
  },
  "colors.gradients.light": {
    "value": "linear-gradient(0deg, rgba(255, 255, 255, 0.85) 0%, rgba(255, 255, 255, 0.85) 100%), radial-gradient(92.76% 73.33% at -2% -4.67%, #623875 0%, rgba(98, 56, 117, 0.00) 100%), radial-gradient(173.95% 133.06% at 110% 111.33%, rgba(51, 196, 179, 0.90) 0%, rgba(51, 196, 179, 0.00) 100%), linear-gradient(0deg, #EED9FA 0%, #DBACF5 66%)",
    "variable": "var(--colors-gradients-light)"
  },
  "colors.gradients.glass": {
    "value": "linear-gradient(114deg, rgba(255, 255, 255, 0.60) 2.72%, rgba(255, 255, 255, 0.80) 100.25%)",
    "variable": "var(--colors-gradients-glass)"
  },
  "colors.gradients.gold": {
    "value": "linear-gradient(0deg, #ffd08b 0%, #e88b03 100%)",
    "variable": "var(--colors-gradients-gold)"
  },
  "colors.graphGradients.primaryFill": {
    "value": "linear-gradient(0deg, #216d97 0%, #ffffff 100%)",
    "variable": "var(--colors-graph-gradients-primary-fill)"
  },
  "colors.graphGradients.primaryStroke": {
    "value": "linear-gradient(0deg, #a9c6d7 0%, #216d97 100%)",
    "variable": "var(--colors-graph-gradients-primary-stroke)"
  },
  "colors.graphGradients.secondaryFill": {
    "value": "linear-gradient(0deg, #ff9903 0%, #ffffff 100%)",
    "variable": "var(--colors-graph-gradients-secondary-fill)"
  },
  "colors.graphGradients.secondaryStroke": {
    "value": "linear-gradient(0deg, #ffd08b 0%, #ff9903 100%)",
    "variable": "var(--colors-graph-gradients-secondary-stroke)"
  },
  "colors.graphGradients.tertiaryFill": {
    "value": "linear-gradient(0deg, #549288 0%, #ffffff 100%)",
    "variable": "var(--colors-graph-gradients-tertiary-fill)"
  },
  "colors.graphGradients.tertiaryStroke": {
    "value": "linear-gradient(0deg, #8ab4ad 0%, #549288 100%)",
    "variable": "var(--colors-graph-gradients-tertiary-stroke)"
  },
  "colors.graphGradients.quaternaryFill": {
    "value": "linear-gradient(0deg, #dbacf5 0%, #ffffff 100%)",
    "variable": "var(--colors-graph-gradients-quaternary-fill)"
  },
  "colors.graphGradients.quaternaryStroke": {
    "value": "linear-gradient(0deg, #eed9fa 0%, #dbacf5 100%)",
    "variable": "var(--colors-graph-gradients-quaternary-stroke)"
  },
  "colors.graphGradients.quinaryFill": {
    "value": "linear-gradient(0deg, #ff375b 0%, #ffffff 100%)",
    "variable": "var(--colors-graph-gradients-quinary-fill)"
  },
  "colors.graphGradients.quinaryStroke": {
    "value": "linear-gradient(0deg, #ffa3b4 0%, #ff375b 100%)",
    "variable": "var(--colors-graph-gradients-quinary-stroke)"
  },
  "colors.graphGradients.senaryFill": {
    "value": "linear-gradient(0deg, #e88b03 0%, #ffffff 100%)",
    "variable": "var(--colors-graph-gradients-senary-fill)"
  },
  "colors.graphGradients.senaryStroke": {
    "value": "linear-gradient(0deg, #ffd08b 0%, #e88b03 100%)",
    "variable": "var(--colors-graph-gradients-senary-stroke)"
  },
  "colors.graphGradients.septenaryFill": {
    "value": "linear-gradient(0deg, #a1000b 0%, #ffffff 100%)",
    "variable": "var(--colors-graph-gradients-septenary-fill)"
  },
  "colors.graphGradients.septenaryStroke": {
    "value": "linear-gradient(0deg, #f28a91 0%, #a1000b 100%)",
    "variable": "var(--colors-graph-gradients-septenary-stroke)"
  },
  "colors.graphGradients.octonaryFill": {
    "value": "linear-gradient(0deg, #0c1436 0%, #ffffff 100%)",
    "variable": "var(--colors-graph-gradients-octonary-fill)"
  },
  "colors.graphGradients.octonaryStroke": {
    "value": "linear-gradient(0deg, #8f93a3 0%, #0c1436 100%)",
    "variable": "var(--colors-graph-gradients-octonary-stroke)"
  },
  "colors.graphGradients.nonaryFill": {
    "value": "linear-gradient(0deg, #b5ada7 0%, #ffffff 100%)",
    "variable": "var(--colors-graph-gradients-nonary-fill)"
  },
  "colors.graphGradients.nonaryStroke": {
    "value": "linear-gradient(0deg, #e8ddd6 0%, #b5ada7 100%)",
    "variable": "var(--colors-graph-gradients-nonary-stroke)"
  },
  "colors.graphGradients.denaryFill": {
    "value": "linear-gradient(0deg, #8c5402 0%, #ffffff 100%)",
    "variable": "var(--colors-graph-gradients-denary-fill)"
  },
  "colors.graphGradients.denaryStroke": {
    "value": "linear-gradient(0deg, #ffad35 0%, #8c5402 100%)",
    "variable": "var(--colors-graph-gradients-denary-stroke)"
  },
  "colors.segmentPrimary": {
    "value": "#216d97",
    "variable": "var(--colors-segment-primary)"
  },
  "colors.segmentSecondary": {
    "value": "#ff9903",
    "variable": "var(--colors-segment-secondary)"
  },
  "colors.segmentTertiary": {
    "value": "#549288",
    "variable": "var(--colors-segment-tertiary)"
  },
  "colors.segmentQuaternary": {
    "value": "#dbacf5",
    "variable": "var(--colors-segment-quaternary)"
  },
  "colors.segmentQuinary": {
    "value": "#ff375b",
    "variable": "var(--colors-segment-quinary)"
  },
  "colors.segmentSenary": {
    "value": "#e88b03",
    "variable": "var(--colors-segment-senary)"
  },
  "colors.segments.primary.300": {
    "value": "#2b8ec4",
    "variable": "var(--colors-segments-primary-300)"
  },
  "colors.segments.primary.500": {
    "value": "#216d97",
    "variable": "var(--colors-segments-primary-500)"
  },
  "colors.segments.primary.600": {
    "value": "#1a5779",
    "variable": "var(--colors-segments-primary-600)"
  },
  "colors.segments.secondary.300": {
    "value": "#ffc704",
    "variable": "var(--colors-segments-secondary-300)"
  },
  "colors.segments.secondary.500": {
    "value": "#ff9903",
    "variable": "var(--colors-segments-secondary-500)"
  },
  "colors.segments.secondary.600": {
    "value": "#cc7a02",
    "variable": "var(--colors-segments-secondary-600)"
  },
  "colors.segments.tertiary.300": {
    "value": "#6dbeb1",
    "variable": "var(--colors-segments-tertiary-300)"
  },
  "colors.segments.tertiary.500": {
    "value": "#549288",
    "variable": "var(--colors-segments-tertiary-500)"
  },
  "colors.segments.tertiary.600": {
    "value": "#43756d",
    "variable": "var(--colors-segments-tertiary-600)"
  },
  "colors.segments.quaternary.300": {
    "value": "#ffe0ff",
    "variable": "var(--colors-segments-quaternary-300)"
  },
  "colors.segments.quaternary.500": {
    "value": "#dbacf5",
    "variable": "var(--colors-segments-quaternary-500)"
  },
  "colors.segments.quaternary.600": {
    "value": "#af8ac4",
    "variable": "var(--colors-segments-quaternary-600)"
  },
  "colors.segments.quinary.300": {
    "value": "#ff4876",
    "variable": "var(--colors-segments-quinary-300)"
  },
  "colors.segments.quinary.500": {
    "value": "#ff375b",
    "variable": "var(--colors-segments-quinary-500)"
  },
  "colors.segments.quinary.600": {
    "value": "#cc2c49",
    "variable": "var(--colors-segments-quinary-600)"
  },
  "colors.segments.senary.300": {
    "value": "#ffb504",
    "variable": "var(--colors-segments-senary-300)"
  },
  "colors.segments.senary.500": {
    "value": "#e88b03",
    "variable": "var(--colors-segments-senary-500)"
  },
  "colors.segments.senary.600": {
    "value": "#ba6f02",
    "variable": "var(--colors-segments-senary-600)"
  },
  "colors.subtitle": {
    "value": "#8f93a3",
    "variable": "var(--colors-subtitle)"
  },
  "colors.border.light": {
    "value": "#e7e8eb",
    "variable": "var(--colors-border-light)"
  },
  "colors.outlineColor": {
    "value": "#62387533",
    "variable": "var(--colors-outline-color)"
  },
  "colors.cases.inbound": {
    "value": "linear-gradient(131deg, #FBF4E5 7.57%, #FEEBC8 86.83%)",
    "variable": "var(--colors-cases-inbound)"
  },
  "colors.cases.outbound": {
    "value": "linear-gradient(107deg, #EEF7FB 10.21%, #E2F0F9 66.35%)",
    "variable": "var(--colors-cases-outbound)"
  },
  "colors.cases.autoReply": {
    "value": "linear-gradient(243deg, #FAFAFA 11.91%, #F5F5F5 81.22%)",
    "variable": "var(--colors-cases-auto-reply)"
  },
  "colors.workspace.bodyBackground": {
    "value": "#ffffff",
    "variable": "var(--colors-workspace-body-background)"
  },
  "colors.workspace.contentBackground": {
    "value": "linear-gradient(114deg, rgba(255, 255, 255, 0.60) 2.72%, rgba(255, 255, 255, 0.80) 100.25%)",
    "variable": "var(--colors-workspace-content-background)"
  },
  "colors.workspace.contentBorder": {
    "value": "#ffffff",
    "variable": "var(--colors-workspace-content-border)"
  },
  "colors.workspace.sidebar.darkbg": {
    "value": "linear-gradient(0deg, rgba(98, 56, 117, 0.50) 0%, rgba(98, 56, 117, 0.50) 100%), radial-gradient(109.42% 85.6% at -2% -4.67%, rgba(51, 196, 179, 0.75) 0%, rgba(51, 196, 179, 0.00) 100%), radial-gradient(167.07% 153.23% at 130.67% 154.67%, rgba(255, 153, 3, 0.50) 0.19%, rgba(255, 153, 3, 0.25) 65%, rgba(255, 153, 3, 0.00) 100%), linear-gradient(91deg, #462853 0%, #623875 35%, #C79DDF 100%)",
    "variable": "var(--colors-workspace-sidebar-darkbg)"
  },
  "colors.workspace.sidebar.lightbg": {
    "value": "linear-gradient(0deg, rgba(255, 255, 255, 0.85) 0%, rgba(255, 255, 255, 0.85) 100%), radial-gradient(92.76% 73.33% at -2% -4.67%, rgba(255, 153, 3, 0.40) 0%, rgba(255, 153, 3, 0.00) 100%), radial-gradient(173.95% 133.06% at 110% 111.33%, rgba(255, 153, 3, 0.30) 0%, rgba(255, 153, 3, 0.00) 100%), #FFF",
    "variable": "var(--colors-workspace-sidebar-lightbg)"
  },
  "colors.workspace.sidebar.text": {
    "value": "#0c1436",
    "variable": "var(--colors-workspace-sidebar-text)"
  },
  "colors.workspace.sidebar.headerText": {
    "value": "#5c6278",
    "variable": "var(--colors-workspace-sidebar-header-text)"
  },
  "colors.card.bg": {
    "value": "#ffffff",
    "variable": "var(--colors-card-bg)"
  },
  "colors.card.header.title": {
    "value": "#0c1436",
    "variable": "var(--colors-card-header-title)"
  },
  "colors.card.header.subtitle": {
    "value": "#5c6278",
    "variable": "var(--colors-card-header-subtitle)"
  },
  "colors.card.borderColor": {
    "value": "#e7e8eb",
    "variable": "var(--colors-card-border-color)"
  },
  "colors.success": {
    "value": "#33c4b3",
    "variable": "var(--colors-success)"
  },
  "colors.warning": {
    "value": "#ff9903",
    "variable": "var(--colors-warning)"
  },
  "colors.warningDark": {
    "value": "#b56d02",
    "variable": "var(--colors-warning-dark)"
  },
  "colors.warningLight": {
    "value": "#ffdfb1",
    "variable": "var(--colors-warning-light)"
  },
  "colors.info": {
    "value": "#8f93a3",
    "variable": "var(--colors-info)"
  },
  "colors.positive": {
    "value": "#00884b",
    "variable": "var(--colors-positive)"
  },
  "colors.negative": {
    "value": "#B52741",
    "variable": "var(--colors-negative)"
  },
  "colors.textMuted": {
    "value": "#5c6278",
    "variable": "var(--colors-text-muted)"
  },
  "colors.text": {
    "value": "#0c1436",
    "variable": "var(--colors-text)"
  },
  "colors.google": {
    "value": "#4285F4",
    "variable": "var(--colors-google)"
  },
  "colors.microsoft": {
    "value": "#DC3E15",
    "variable": "var(--colors-microsoft)"
  },
  "shadows.2xs": {
    "value": "0 1px rgb(0 0 0 / 0.05)",
    "variable": "var(--shadows-2xs)"
  },
  "shadows.xs": {
    "value": "0 1px 2px 0 rgb(0 0 0 / 0.05)",
    "variable": "var(--shadows-xs)"
  },
  "shadows.sm": {
    "value": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
    "variable": "var(--shadows-sm)"
  },
  "shadows.inset-2xs": {
    "value": "inset 0 1px rgb(0 0 0 / 0.05)",
    "variable": "var(--shadows-inset-2xs)"
  },
  "shadows.inset-xs": {
    "value": "inset 0 1px 1px rgb(0 0 0 / 0.05)",
    "variable": "var(--shadows-inset-xs)"
  },
  "shadows.inset-sm": {
    "value": "inset 0 2px 4px rgb(0 0 0 / 0.05)",
    "variable": "var(--shadows-inset-sm)"
  },
  "shadows.base": {
    "value": "0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04)",
    "variable": "var(--shadows-base)"
  },
  "shadows.md": {
    "value": "0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)",
    "variable": "var(--shadows-md)"
  },
  "shadows.lg": {
    "value": "0px 16px 24px rgba(0, 0, 0, 0.06), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)",
    "variable": "var(--shadows-lg)"
  },
  "shadows.extended": {
    "value": "0px 1px 1px 0px rgba(0, 0, 0, 0.10), 0px 2px 2px 0px rgba(0, 0, 0, 0.09), 0px 5px 3px 0px rgba(0, 0, 0, 0.05), 0px 10px 4px 0px rgba(0, 0, 0, 0.01), 0px 15px 4px 0px rgba(0, 0, 0, 0.00)",
    "variable": "var(--shadows-extended)"
  },
  "shadows.textExtended": {
    "value": "0px 15px 4px rgba(0, 0, 0, 0.00), 0px 10px 4px rgba(0, 0, 0, 0.01), 0px 5px 3px rgba(0, 0, 0, 0.05), 0px 2px 2px rgba(0, 0, 0, 0.09), 0px 1px 1px rgba(0, 0, 0, 0.10)",
    "variable": "var(--shadows-text-extended)"
  },
  "shadows.xl": {
    "value": "0px 24px 32px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)",
    "variable": "var(--shadows-xl)"
  },
  "shadows.2xl": {
    "value": "0px 36px 80px rgba(0, 0, 0, 0.07), 0px 23.3333px 46.8519px rgba(0, 0, 0, 0.0531481), 0px 13.8667px 25.4815px rgba(0, 0, 0, 0.0425185), 0px 7.2px 13px rgba(0, 0, 0, 0.035), 0px 2.93333px 6.51852px rgba(0, 0, 0, 0.0274815), 0px 0.666667px 3.14815px rgba(0, 0, 0, 0.0168519)",
    "variable": "var(--shadows-2xl)"
  },
  "shadows.outline": {
    "value": "0 0 0 3px #62387533",
    "variable": "var(--shadows-outline)"
  },
  "shadows.inputOutline": {
    "value": "0px 2px 0px 0px #e7e8eb",
    "variable": "var(--shadows-input-outline)"
  },
  "shadows.kbd-inner": {
    "value": "0px -2px 0px 0px #E2E8F0 inset",
    "variable": "var(--shadows-kbd-inner)"
  },
  "shadows.dark-lg": {
    "value": "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px,rgba(0, 0, 0, 0.2) 0px 5px 10px,rgba(0, 0, 0, 0.4) 0px 15px 40px",
    "variable": "var(--shadows-dark-lg)"
  },
  "shadows.glassShadow": {
    "value": "89px 44px 28px 0px rgba(70, 40, 83, 0.00), 57px 28px 25px 0px rgba(70, 40, 83, 0.01), 32px 16px 21px 0px rgba(70, 40, 83, 0.03), 14px 7px 16px 0px rgba(70, 40, 83, 0.04), 4px 2px 9px 0px rgba(70, 40, 83, 0.05)",
    "variable": "var(--shadows-glass-shadow)"
  },
  "fonts.sans": {
    "value": "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"",
    "variable": "var(--fonts-sans)"
  },
  "fonts.serif": {
    "value": "ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
    "variable": "var(--fonts-serif)"
  },
  "fonts.mono": {
    "value": "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace",
    "variable": "var(--fonts-mono)"
  },
  "fonts.body": {
    "value": "\"Poppins\", sans-serif",
    "variable": "var(--fonts-body)"
  },
  "fonts.heading": {
    "value": "\"Noto Serif Display\", sans-serif",
    "variable": "var(--fonts-heading)"
  },
  "fontSizes.2xs": {
    "value": "0.5rem",
    "variable": "var(--font-sizes-2xs)"
  },
  "fontSizes.7xl": {
    "value": "4.5rem",
    "variable": "var(--font-sizes-7xl)"
  },
  "fontSizes.8xl": {
    "value": "6rem",
    "variable": "var(--font-sizes-8xl)"
  },
  "fontSizes.9xl": {
    "value": "8rem",
    "variable": "var(--font-sizes-9xl)"
  },
  "fontSizes.xs": {
    "value": "0.6875rem",
    "variable": "var(--font-sizes-xs)"
  },
  "fontSizes.sm": {
    "value": "0.75rem",
    "variable": "var(--font-sizes-sm)"
  },
  "fontSizes.md": {
    "value": "0.875rem",
    "variable": "var(--font-sizes-md)"
  },
  "fontSizes.lg": {
    "value": "1rem",
    "variable": "var(--font-sizes-lg)"
  },
  "fontSizes.xl": {
    "value": "1.125rem",
    "variable": "var(--font-sizes-xl)"
  },
  "fontSizes.2xl": {
    "value": "1.25rem",
    "variable": "var(--font-sizes-2xl)"
  },
  "fontSizes.3xl": {
    "value": "1.5rem",
    "variable": "var(--font-sizes-3xl)"
  },
  "fontSizes.4xl": {
    "value": "1.875rem",
    "variable": "var(--font-sizes-4xl)"
  },
  "fontSizes.5xl": {
    "value": "2.25rem",
    "variable": "var(--font-sizes-5xl)"
  },
  "fontSizes.6xl": {
    "value": "3rem",
    "variable": "var(--font-sizes-6xl)"
  },
  "sizes.0": {
    "value": "0rem",
    "variable": "var(--sizes-0)"
  },
  "sizes.1": {
    "value": "0.25rem",
    "variable": "var(--sizes-1)"
  },
  "sizes.2": {
    "value": "0.5rem",
    "variable": "var(--sizes-2)"
  },
  "sizes.3": {
    "value": "0.75rem",
    "variable": "var(--sizes-3)"
  },
  "sizes.4": {
    "value": "1rem",
    "variable": "var(--sizes-4)"
  },
  "sizes.5": {
    "value": "1.25rem",
    "variable": "var(--sizes-5)"
  },
  "sizes.6": {
    "value": "1.5rem",
    "variable": "var(--sizes-6)"
  },
  "sizes.7": {
    "value": "1.75rem",
    "variable": "var(--sizes-7)"
  },
  "sizes.8": {
    "value": "2rem",
    "variable": "var(--sizes-8)"
  },
  "sizes.9": {
    "value": "2.25rem",
    "variable": "var(--sizes-9)"
  },
  "sizes.10": {
    "value": "2.5rem",
    "variable": "var(--sizes-10)"
  },
  "sizes.11": {
    "value": "2.75rem",
    "variable": "var(--sizes-11)"
  },
  "sizes.12": {
    "value": "3rem",
    "variable": "var(--sizes-12)"
  },
  "sizes.14": {
    "value": "3.5rem",
    "variable": "var(--sizes-14)"
  },
  "sizes.16": {
    "value": "4rem",
    "variable": "var(--sizes-16)"
  },
  "sizes.20": {
    "value": "5rem",
    "variable": "var(--sizes-20)"
  },
  "sizes.24": {
    "value": "6rem",
    "variable": "var(--sizes-24)"
  },
  "sizes.28": {
    "value": "7rem",
    "variable": "var(--sizes-28)"
  },
  "sizes.32": {
    "value": "8rem",
    "variable": "var(--sizes-32)"
  },
  "sizes.36": {
    "value": "9rem",
    "variable": "var(--sizes-36)"
  },
  "sizes.40": {
    "value": "10rem",
    "variable": "var(--sizes-40)"
  },
  "sizes.44": {
    "value": "11rem",
    "variable": "var(--sizes-44)"
  },
  "sizes.48": {
    "value": "12rem",
    "variable": "var(--sizes-48)"
  },
  "sizes.52": {
    "value": "13rem",
    "variable": "var(--sizes-52)"
  },
  "sizes.56": {
    "value": "14rem",
    "variable": "var(--sizes-56)"
  },
  "sizes.60": {
    "value": "15rem",
    "variable": "var(--sizes-60)"
  },
  "sizes.64": {
    "value": "16rem",
    "variable": "var(--sizes-64)"
  },
  "sizes.72": {
    "value": "18rem",
    "variable": "var(--sizes-72)"
  },
  "sizes.80": {
    "value": "20rem",
    "variable": "var(--sizes-80)"
  },
  "sizes.96": {
    "value": "24rem",
    "variable": "var(--sizes-96)"
  },
  "sizes.4.5": {
    "value": "1.125rem",
    "variable": "var(--sizes-4\\.5)"
  },
  "sizes.5.5": {
    "value": "1.375rem",
    "variable": "var(--sizes-5\\.5)"
  },
  "sizes.fit": {
    "value": "fit-content",
    "variable": "var(--sizes-fit)"
  },
  "sizes.px": {
    "value": "1px",
    "variable": "var(--sizes-px)"
  },
  "sizes.0.5": {
    "value": "0.125rem",
    "variable": "var(--sizes-0\\.5)"
  },
  "sizes.1.5": {
    "value": "0.375rem",
    "variable": "var(--sizes-1\\.5)"
  },
  "sizes.2.5": {
    "value": "0.625rem",
    "variable": "var(--sizes-2\\.5)"
  },
  "sizes.3.5": {
    "value": "0.875rem",
    "variable": "var(--sizes-3\\.5)"
  },
  "sizes.max": {
    "value": "max-content",
    "variable": "var(--sizes-max)"
  },
  "sizes.min": {
    "value": "min-content",
    "variable": "var(--sizes-min)"
  },
  "sizes.full": {
    "value": "100%",
    "variable": "var(--sizes-full)"
  },
  "sizes.3xs": {
    "value": "14rem",
    "variable": "var(--sizes-3xs)"
  },
  "sizes.2xs": {
    "value": "16rem",
    "variable": "var(--sizes-2xs)"
  },
  "sizes.xs": {
    "value": "20rem",
    "variable": "var(--sizes-xs)"
  },
  "sizes.sm": {
    "value": "24rem",
    "variable": "var(--sizes-sm)"
  },
  "sizes.md": {
    "value": "28rem",
    "variable": "var(--sizes-md)"
  },
  "sizes.lg": {
    "value": "32rem",
    "variable": "var(--sizes-lg)"
  },
  "sizes.xl": {
    "value": "36rem",
    "variable": "var(--sizes-xl)"
  },
  "sizes.2xl": {
    "value": "42rem",
    "variable": "var(--sizes-2xl)"
  },
  "sizes.3xl": {
    "value": "48rem",
    "variable": "var(--sizes-3xl)"
  },
  "sizes.4xl": {
    "value": "56rem",
    "variable": "var(--sizes-4xl)"
  },
  "sizes.5xl": {
    "value": "64rem",
    "variable": "var(--sizes-5xl)"
  },
  "sizes.6xl": {
    "value": "72rem",
    "variable": "var(--sizes-6xl)"
  },
  "sizes.7xl": {
    "value": "80rem",
    "variable": "var(--sizes-7xl)"
  },
  "sizes.8xl": {
    "value": "90rem",
    "variable": "var(--sizes-8xl)"
  },
  "sizes.prose": {
    "value": "60ch",
    "variable": "var(--sizes-prose)"
  },
  "sizes.container.sm": {
    "value": "640px",
    "variable": "var(--sizes-container-sm)"
  },
  "sizes.container.md": {
    "value": "768px",
    "variable": "var(--sizes-container-md)"
  },
  "sizes.container.lg": {
    "value": "1024px",
    "variable": "var(--sizes-container-lg)"
  },
  "sizes.container.xl": {
    "value": "1280px",
    "variable": "var(--sizes-container-xl)"
  },
  "sizes.container.2xl": {
    "value": "1536px",
    "variable": "var(--sizes-container-2xl)"
  },
  "sizes.breakpoint-sm": {
    "value": "30em",
    "variable": "var(--sizes-breakpoint-sm)"
  },
  "sizes.breakpoint-md": {
    "value": "48em",
    "variable": "var(--sizes-breakpoint-md)"
  },
  "sizes.breakpoint-lg": {
    "value": "62em",
    "variable": "var(--sizes-breakpoint-lg)"
  },
  "sizes.breakpoint-xl": {
    "value": "80em",
    "variable": "var(--sizes-breakpoint-xl)"
  },
  "sizes.breakpoint-1.5xl": {
    "value": "85em",
    "variable": "var(--sizes-breakpoint-1\\.5xl)"
  },
  "sizes.breakpoint-2xl": {
    "value": "96em",
    "variable": "var(--sizes-breakpoint-2xl)"
  },
  "sizes.breakpoint-3xl": {
    "value": "118.75em",
    "variable": "var(--sizes-breakpoint-3xl)"
  },
  "animations.spin": {
    "value": "spin 1s linear infinite",
    "variable": "var(--animations-spin)"
  },
  "animations.ping": {
    "value": "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
    "variable": "var(--animations-ping)"
  },
  "animations.pulse": {
    "value": "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
    "variable": "var(--animations-pulse)"
  },
  "animations.bounce": {
    "value": "bounce 1s infinite",
    "variable": "var(--animations-bounce)"
  },
  "animations.fadeInSm": {
    "value": "fadeIn 140ms ease-in both",
    "variable": "var(--animations-fade-in-sm)"
  },
  "animations.fadeColor": {
    "value": "fadeColor 2s ease 250ms",
    "variable": "var(--animations-fade-color)"
  },
  "breakpoints.sm": {
    "value": "30em",
    "variable": "var(--breakpoints-sm)"
  },
  "breakpoints.md": {
    "value": "48em",
    "variable": "var(--breakpoints-md)"
  },
  "breakpoints.lg": {
    "value": "62em",
    "variable": "var(--breakpoints-lg)"
  },
  "breakpoints.xl": {
    "value": "80em",
    "variable": "var(--breakpoints-xl)"
  },
  "breakpoints.1.5xl": {
    "value": "85em",
    "variable": "var(--breakpoints-1\\.5xl)"
  },
  "breakpoints.2xl": {
    "value": "96em",
    "variable": "var(--breakpoints-2xl)"
  },
  "breakpoints.3xl": {
    "value": "118.75em",
    "variable": "var(--breakpoints-3xl)"
  },
  "spacing.-1": {
    "value": "calc(var(--spacing-1) * -1)",
    "variable": "var(--spacing-1)"
  },
  "spacing.-2": {
    "value": "calc(var(--spacing-2) * -1)",
    "variable": "var(--spacing-2)"
  },
  "spacing.-3": {
    "value": "calc(var(--spacing-3) * -1)",
    "variable": "var(--spacing-3)"
  },
  "spacing.-4": {
    "value": "calc(var(--spacing-4) * -1)",
    "variable": "var(--spacing-4)"
  },
  "spacing.-5": {
    "value": "calc(var(--spacing-5) * -1)",
    "variable": "var(--spacing-5)"
  },
  "spacing.-6": {
    "value": "calc(var(--spacing-6) * -1)",
    "variable": "var(--spacing-6)"
  },
  "spacing.-7": {
    "value": "calc(var(--spacing-7) * -1)",
    "variable": "var(--spacing-7)"
  },
  "spacing.-8": {
    "value": "calc(var(--spacing-8) * -1)",
    "variable": "var(--spacing-8)"
  },
  "spacing.-9": {
    "value": "calc(var(--spacing-9) * -1)",
    "variable": "var(--spacing-9)"
  },
  "spacing.-10": {
    "value": "calc(var(--spacing-10) * -1)",
    "variable": "var(--spacing-10)"
  },
  "spacing.-11": {
    "value": "calc(var(--spacing-11) * -1)",
    "variable": "var(--spacing-11)"
  },
  "spacing.-12": {
    "value": "calc(var(--spacing-12) * -1)",
    "variable": "var(--spacing-12)"
  },
  "spacing.-14": {
    "value": "calc(var(--spacing-14) * -1)",
    "variable": "var(--spacing-14)"
  },
  "spacing.-16": {
    "value": "calc(var(--spacing-16) * -1)",
    "variable": "var(--spacing-16)"
  },
  "spacing.-20": {
    "value": "calc(var(--spacing-20) * -1)",
    "variable": "var(--spacing-20)"
  },
  "spacing.-24": {
    "value": "calc(var(--spacing-24) * -1)",
    "variable": "var(--spacing-24)"
  },
  "spacing.-28": {
    "value": "calc(var(--spacing-28) * -1)",
    "variable": "var(--spacing-28)"
  },
  "spacing.-32": {
    "value": "calc(var(--spacing-32) * -1)",
    "variable": "var(--spacing-32)"
  },
  "spacing.-36": {
    "value": "calc(var(--spacing-36) * -1)",
    "variable": "var(--spacing-36)"
  },
  "spacing.-40": {
    "value": "calc(var(--spacing-40) * -1)",
    "variable": "var(--spacing-40)"
  },
  "spacing.-44": {
    "value": "calc(var(--spacing-44) * -1)",
    "variable": "var(--spacing-44)"
  },
  "spacing.-48": {
    "value": "calc(var(--spacing-48) * -1)",
    "variable": "var(--spacing-48)"
  },
  "spacing.-52": {
    "value": "calc(var(--spacing-52) * -1)",
    "variable": "var(--spacing-52)"
  },
  "spacing.-56": {
    "value": "calc(var(--spacing-56) * -1)",
    "variable": "var(--spacing-56)"
  },
  "spacing.-60": {
    "value": "calc(var(--spacing-60) * -1)",
    "variable": "var(--spacing-60)"
  },
  "spacing.-64": {
    "value": "calc(var(--spacing-64) * -1)",
    "variable": "var(--spacing-64)"
  },
  "spacing.-72": {
    "value": "calc(var(--spacing-72) * -1)",
    "variable": "var(--spacing-72)"
  },
  "spacing.-80": {
    "value": "calc(var(--spacing-80) * -1)",
    "variable": "var(--spacing-80)"
  },
  "spacing.-96": {
    "value": "calc(var(--spacing-96) * -1)",
    "variable": "var(--spacing-96)"
  },
  "spacing.-0.5": {
    "value": "calc(var(--spacing-0\\.5) * -1)",
    "variable": "var(--spacing-0\\.5)"
  },
  "spacing.-1.5": {
    "value": "calc(var(--spacing-1\\.5) * -1)",
    "variable": "var(--spacing-1\\.5)"
  },
  "spacing.-2.5": {
    "value": "calc(var(--spacing-2\\.5) * -1)",
    "variable": "var(--spacing-2\\.5)"
  },
  "spacing.-3.5": {
    "value": "calc(var(--spacing-3\\.5) * -1)",
    "variable": "var(--spacing-3\\.5)"
  },
  "spacing.-4.5": {
    "value": "calc(var(--spacing-4\\.5) * -1)",
    "variable": "var(--spacing-4\\.5)"
  },
  "spacing.-5.5": {
    "value": "calc(var(--spacing-5\\.5) * -1)",
    "variable": "var(--spacing-5\\.5)"
  },
  "colors.colorPalette.50": {
    "value": "var(--colors-color-palette-50)",
    "variable": "var(--colors-color-palette-50)"
  },
  "colors.colorPalette.100": {
    "value": "var(--colors-color-palette-100)",
    "variable": "var(--colors-color-palette-100)"
  },
  "colors.colorPalette.200": {
    "value": "var(--colors-color-palette-200)",
    "variable": "var(--colors-color-palette-200)"
  },
  "colors.colorPalette.300": {
    "value": "var(--colors-color-palette-300)",
    "variable": "var(--colors-color-palette-300)"
  },
  "colors.colorPalette.400": {
    "value": "var(--colors-color-palette-400)",
    "variable": "var(--colors-color-palette-400)"
  },
  "colors.colorPalette.500": {
    "value": "var(--colors-color-palette-500)",
    "variable": "var(--colors-color-palette-500)"
  },
  "colors.colorPalette.600": {
    "value": "var(--colors-color-palette-600)",
    "variable": "var(--colors-color-palette-600)"
  },
  "colors.colorPalette.700": {
    "value": "var(--colors-color-palette-700)",
    "variable": "var(--colors-color-palette-700)"
  },
  "colors.colorPalette.800": {
    "value": "var(--colors-color-palette-800)",
    "variable": "var(--colors-color-palette-800)"
  },
  "colors.colorPalette.900": {
    "value": "var(--colors-color-palette-900)",
    "variable": "var(--colors-color-palette-900)"
  },
  "colors.colorPalette.950": {
    "value": "var(--colors-color-palette-950)",
    "variable": "var(--colors-color-palette-950)"
  },
  "colors.colorPalette": {
    "value": "var(--colors-color-palette)",
    "variable": "var(--colors-color-palette)"
  },
  "colors.colorPalette.primary": {
    "value": "var(--colors-color-palette-primary)",
    "variable": "var(--colors-color-palette-primary)"
  },
  "colors.colorPalette.secondary": {
    "value": "var(--colors-color-palette-secondary)",
    "variable": "var(--colors-color-palette-secondary)"
  },
  "colors.colorPalette.main": {
    "value": "var(--colors-color-palette-main)",
    "variable": "var(--colors-color-palette-main)"
  },
  "colors.colorPalette.light": {
    "value": "var(--colors-color-palette-light)",
    "variable": "var(--colors-color-palette-light)"
  },
  "colors.colorPalette.dark": {
    "value": "var(--colors-color-palette-dark)",
    "variable": "var(--colors-color-palette-dark)"
  },
  "colors.colorPalette.white": {
    "value": "var(--colors-color-palette-white)",
    "variable": "var(--colors-color-palette-white)"
  },
  "colors.colorPalette.informationFocus": {
    "value": "var(--colors-color-palette-information-focus)",
    "variable": "var(--colors-color-palette-information-focus)"
  },
  "colors.colorPalette.dividerStroke": {
    "value": "var(--colors-color-palette-divider-stroke)",
    "variable": "var(--colors-color-palette-divider-stroke)"
  },
  "colors.colorPalette.glassStroke": {
    "value": "var(--colors-color-palette-glass-stroke)",
    "variable": "var(--colors-color-palette-glass-stroke)"
  },
  "colors.colorPalette.contactCentreLight": {
    "value": "var(--colors-color-palette-contact-centre-light)",
    "variable": "var(--colors-color-palette-contact-centre-light)"
  },
  "colors.colorPalette.virtualAgentsMain": {
    "value": "var(--colors-color-palette-virtual-agents-main)",
    "variable": "var(--colors-color-palette-virtual-agents-main)"
  },
  "colors.colorPalette.virtualAgentsLight": {
    "value": "var(--colors-color-palette-virtual-agents-light)",
    "variable": "var(--colors-color-palette-virtual-agents-light)"
  },
  "colors.colorPalette.conversationIntelligenceMain": {
    "value": "var(--colors-color-palette-conversation-intelligence-main)",
    "variable": "var(--colors-color-palette-conversation-intelligence-main)"
  },
  "colors.colorPalette.conversationIntelligenceLight": {
    "value": "var(--colors-color-palette-conversation-intelligence-light)",
    "variable": "var(--colors-color-palette-conversation-intelligence-light)"
  },
  "colors.colorPalette.workforceManagementMain": {
    "value": "var(--colors-color-palette-workforce-management-main)",
    "variable": "var(--colors-color-palette-workforce-management-main)"
  },
  "colors.colorPalette.workforceManagementLight": {
    "value": "var(--colors-color-palette-workforce-management-light)",
    "variable": "var(--colors-color-palette-workforce-management-light)"
  },
  "colors.colorPalette.caseManagementMain": {
    "value": "var(--colors-color-palette-case-management-main)",
    "variable": "var(--colors-color-palette-case-management-main)"
  },
  "colors.colorPalette.caseManagementLight": {
    "value": "var(--colors-color-palette-case-management-light)",
    "variable": "var(--colors-color-palette-case-management-light)"
  },
  "colors.colorPalette.agentCopilotMain": {
    "value": "var(--colors-color-palette-agent-copilot-main)",
    "variable": "var(--colors-color-palette-agent-copilot-main)"
  },
  "colors.colorPalette.agentCopilotLight": {
    "value": "var(--colors-color-palette-agent-copilot-light)",
    "variable": "var(--colors-color-palette-agent-copilot-light)"
  },
  "colors.colorPalette.primary.300": {
    "value": "var(--colors-color-palette-primary-300)",
    "variable": "var(--colors-color-palette-primary-300)"
  },
  "colors.colorPalette.primary.500": {
    "value": "var(--colors-color-palette-primary-500)",
    "variable": "var(--colors-color-palette-primary-500)"
  },
  "colors.colorPalette.primary.600": {
    "value": "var(--colors-color-palette-primary-600)",
    "variable": "var(--colors-color-palette-primary-600)"
  },
  "colors.colorPalette.secondary.300": {
    "value": "var(--colors-color-palette-secondary-300)",
    "variable": "var(--colors-color-palette-secondary-300)"
  },
  "colors.colorPalette.secondary.500": {
    "value": "var(--colors-color-palette-secondary-500)",
    "variable": "var(--colors-color-palette-secondary-500)"
  },
  "colors.colorPalette.secondary.600": {
    "value": "var(--colors-color-palette-secondary-600)",
    "variable": "var(--colors-color-palette-secondary-600)"
  },
  "colors.colorPalette.tertiary.300": {
    "value": "var(--colors-color-palette-tertiary-300)",
    "variable": "var(--colors-color-palette-tertiary-300)"
  },
  "colors.colorPalette.tertiary.500": {
    "value": "var(--colors-color-palette-tertiary-500)",
    "variable": "var(--colors-color-palette-tertiary-500)"
  },
  "colors.colorPalette.tertiary.600": {
    "value": "var(--colors-color-palette-tertiary-600)",
    "variable": "var(--colors-color-palette-tertiary-600)"
  },
  "colors.colorPalette.quarternary.300": {
    "value": "var(--colors-color-palette-quarternary-300)",
    "variable": "var(--colors-color-palette-quarternary-300)"
  },
  "colors.colorPalette.quarternary.500": {
    "value": "var(--colors-color-palette-quarternary-500)",
    "variable": "var(--colors-color-palette-quarternary-500)"
  },
  "colors.colorPalette.quarternary.600": {
    "value": "var(--colors-color-palette-quarternary-600)",
    "variable": "var(--colors-color-palette-quarternary-600)"
  },
  "colors.colorPalette.quinary.300": {
    "value": "var(--colors-color-palette-quinary-300)",
    "variable": "var(--colors-color-palette-quinary-300)"
  },
  "colors.colorPalette.quinary.500": {
    "value": "var(--colors-color-palette-quinary-500)",
    "variable": "var(--colors-color-palette-quinary-500)"
  },
  "colors.colorPalette.quinary.600": {
    "value": "var(--colors-color-palette-quinary-600)",
    "variable": "var(--colors-color-palette-quinary-600)"
  },
  "colors.colorPalette.senary.300": {
    "value": "var(--colors-color-palette-senary-300)",
    "variable": "var(--colors-color-palette-senary-300)"
  },
  "colors.colorPalette.senary.500": {
    "value": "var(--colors-color-palette-senary-500)",
    "variable": "var(--colors-color-palette-senary-500)"
  },
  "colors.colorPalette.senary.600": {
    "value": "var(--colors-color-palette-senary-600)",
    "variable": "var(--colors-color-palette-senary-600)"
  },
  "colors.colorPalette.septenary.300": {
    "value": "var(--colors-color-palette-septenary-300)",
    "variable": "var(--colors-color-palette-septenary-300)"
  },
  "colors.colorPalette.septenary.500": {
    "value": "var(--colors-color-palette-septenary-500)",
    "variable": "var(--colors-color-palette-septenary-500)"
  },
  "colors.colorPalette.septenary.600": {
    "value": "var(--colors-color-palette-septenary-600)",
    "variable": "var(--colors-color-palette-septenary-600)"
  },
  "colors.colorPalette.octonary.300": {
    "value": "var(--colors-color-palette-octonary-300)",
    "variable": "var(--colors-color-palette-octonary-300)"
  },
  "colors.colorPalette.octonary.500": {
    "value": "var(--colors-color-palette-octonary-500)",
    "variable": "var(--colors-color-palette-octonary-500)"
  },
  "colors.colorPalette.octonary.600": {
    "value": "var(--colors-color-palette-octonary-600)",
    "variable": "var(--colors-color-palette-octonary-600)"
  },
  "colors.colorPalette.nonary.300": {
    "value": "var(--colors-color-palette-nonary-300)",
    "variable": "var(--colors-color-palette-nonary-300)"
  },
  "colors.colorPalette.nonary.500": {
    "value": "var(--colors-color-palette-nonary-500)",
    "variable": "var(--colors-color-palette-nonary-500)"
  },
  "colors.colorPalette.nonary.600": {
    "value": "var(--colors-color-palette-nonary-600)",
    "variable": "var(--colors-color-palette-nonary-600)"
  },
  "colors.colorPalette.denary.300": {
    "value": "var(--colors-color-palette-denary-300)",
    "variable": "var(--colors-color-palette-denary-300)"
  },
  "colors.colorPalette.denary.500": {
    "value": "var(--colors-color-palette-denary-500)",
    "variable": "var(--colors-color-palette-denary-500)"
  },
  "colors.colorPalette.denary.600": {
    "value": "var(--colors-color-palette-denary-600)",
    "variable": "var(--colors-color-palette-denary-600)"
  },
  "colors.colorPalette.success": {
    "value": "var(--colors-color-palette-success)",
    "variable": "var(--colors-color-palette-success)"
  },
  "colors.colorPalette.dangerError": {
    "value": "var(--colors-color-palette-danger-error)",
    "variable": "var(--colors-color-palette-danger-error)"
  },
  "colors.colorPalette.positive": {
    "value": "var(--colors-color-palette-positive)",
    "variable": "var(--colors-color-palette-positive)"
  },
  "colors.colorPalette.negative": {
    "value": "var(--colors-color-palette-negative)",
    "variable": "var(--colors-color-palette-negative)"
  },
  "colors.colorPalette.caution": {
    "value": "var(--colors-color-palette-caution)",
    "variable": "var(--colors-color-palette-caution)"
  },
  "colors.colorPalette.cautionLight": {
    "value": "var(--colors-color-palette-caution-light)",
    "variable": "var(--colors-color-palette-caution-light)"
  },
  "colors.colorPalette.cautionDark": {
    "value": "var(--colors-color-palette-caution-dark)",
    "variable": "var(--colors-color-palette-caution-dark)"
  },
  "colors.colorPalette.dangerErrorLight": {
    "value": "var(--colors-color-palette-danger-error-light)",
    "variable": "var(--colors-color-palette-danger-error-light)"
  },
  "colors.colorPalette.dangerErrorDark": {
    "value": "var(--colors-color-palette-danger-error-dark)",
    "variable": "var(--colors-color-palette-danger-error-dark)"
  },
  "colors.colorPalette.successLight": {
    "value": "var(--colors-color-palette-success-light)",
    "variable": "var(--colors-color-palette-success-light)"
  },
  "colors.colorPalette.successDark": {
    "value": "var(--colors-color-palette-success-dark)",
    "variable": "var(--colors-color-palette-success-dark)"
  },
  "colors.colorPalette.blue": {
    "value": "var(--colors-color-palette-blue)",
    "variable": "var(--colors-color-palette-blue)"
  },
  "colors.colorPalette.sand": {
    "value": "var(--colors-color-palette-sand)",
    "variable": "var(--colors-color-palette-sand)"
  },
  "colors.colorPalette.green": {
    "value": "var(--colors-color-palette-green)",
    "variable": "var(--colors-color-palette-green)"
  },
  "colors.colorPalette.yellow": {
    "value": "var(--colors-color-palette-yellow)",
    "variable": "var(--colors-color-palette-yellow)"
  },
  "colors.colorPalette.red": {
    "value": "var(--colors-color-palette-red)",
    "variable": "var(--colors-color-palette-red)"
  },
  "colors.colorPalette.conversationalintelligence": {
    "value": "var(--colors-color-palette-conversationalintelligence)",
    "variable": "var(--colors-color-palette-conversationalintelligence)"
  },
  "colors.colorPalette.virtualAgents": {
    "value": "var(--colors-color-palette-virtual-agents)",
    "variable": "var(--colors-color-palette-virtual-agents)"
  },
  "colors.colorPalette.aiGradientWeak": {
    "value": "var(--colors-color-palette-ai-gradient-weak)",
    "variable": "var(--colors-color-palette-ai-gradient-weak)"
  },
  "colors.colorPalette.aiGradientStrong": {
    "value": "var(--colors-color-palette-ai-gradient-strong)",
    "variable": "var(--colors-color-palette-ai-gradient-strong)"
  },
  "colors.colorPalette.aiStrokeText": {
    "value": "var(--colors-color-palette-ai-stroke-text)",
    "variable": "var(--colors-color-palette-ai-stroke-text)"
  },
  "colors.colorPalette.glass": {
    "value": "var(--colors-color-palette-glass)",
    "variable": "var(--colors-color-palette-glass)"
  },
  "colors.colorPalette.gold": {
    "value": "var(--colors-color-palette-gold)",
    "variable": "var(--colors-color-palette-gold)"
  },
  "colors.colorPalette.primaryFill": {
    "value": "var(--colors-color-palette-primary-fill)",
    "variable": "var(--colors-color-palette-primary-fill)"
  },
  "colors.colorPalette.primaryStroke": {
    "value": "var(--colors-color-palette-primary-stroke)",
    "variable": "var(--colors-color-palette-primary-stroke)"
  },
  "colors.colorPalette.secondaryFill": {
    "value": "var(--colors-color-palette-secondary-fill)",
    "variable": "var(--colors-color-palette-secondary-fill)"
  },
  "colors.colorPalette.secondaryStroke": {
    "value": "var(--colors-color-palette-secondary-stroke)",
    "variable": "var(--colors-color-palette-secondary-stroke)"
  },
  "colors.colorPalette.tertiaryFill": {
    "value": "var(--colors-color-palette-tertiary-fill)",
    "variable": "var(--colors-color-palette-tertiary-fill)"
  },
  "colors.colorPalette.tertiaryStroke": {
    "value": "var(--colors-color-palette-tertiary-stroke)",
    "variable": "var(--colors-color-palette-tertiary-stroke)"
  },
  "colors.colorPalette.quaternaryFill": {
    "value": "var(--colors-color-palette-quaternary-fill)",
    "variable": "var(--colors-color-palette-quaternary-fill)"
  },
  "colors.colorPalette.quaternaryStroke": {
    "value": "var(--colors-color-palette-quaternary-stroke)",
    "variable": "var(--colors-color-palette-quaternary-stroke)"
  },
  "colors.colorPalette.quinaryFill": {
    "value": "var(--colors-color-palette-quinary-fill)",
    "variable": "var(--colors-color-palette-quinary-fill)"
  },
  "colors.colorPalette.quinaryStroke": {
    "value": "var(--colors-color-palette-quinary-stroke)",
    "variable": "var(--colors-color-palette-quinary-stroke)"
  },
  "colors.colorPalette.senaryFill": {
    "value": "var(--colors-color-palette-senary-fill)",
    "variable": "var(--colors-color-palette-senary-fill)"
  },
  "colors.colorPalette.senaryStroke": {
    "value": "var(--colors-color-palette-senary-stroke)",
    "variable": "var(--colors-color-palette-senary-stroke)"
  },
  "colors.colorPalette.septenaryFill": {
    "value": "var(--colors-color-palette-septenary-fill)",
    "variable": "var(--colors-color-palette-septenary-fill)"
  },
  "colors.colorPalette.septenaryStroke": {
    "value": "var(--colors-color-palette-septenary-stroke)",
    "variable": "var(--colors-color-palette-septenary-stroke)"
  },
  "colors.colorPalette.octonaryFill": {
    "value": "var(--colors-color-palette-octonary-fill)",
    "variable": "var(--colors-color-palette-octonary-fill)"
  },
  "colors.colorPalette.octonaryStroke": {
    "value": "var(--colors-color-palette-octonary-stroke)",
    "variable": "var(--colors-color-palette-octonary-stroke)"
  },
  "colors.colorPalette.nonaryFill": {
    "value": "var(--colors-color-palette-nonary-fill)",
    "variable": "var(--colors-color-palette-nonary-fill)"
  },
  "colors.colorPalette.nonaryStroke": {
    "value": "var(--colors-color-palette-nonary-stroke)",
    "variable": "var(--colors-color-palette-nonary-stroke)"
  },
  "colors.colorPalette.denaryFill": {
    "value": "var(--colors-color-palette-denary-fill)",
    "variable": "var(--colors-color-palette-denary-fill)"
  },
  "colors.colorPalette.denaryStroke": {
    "value": "var(--colors-color-palette-denary-stroke)",
    "variable": "var(--colors-color-palette-denary-stroke)"
  },
  "colors.colorPalette.quaternary.300": {
    "value": "var(--colors-color-palette-quaternary-300)",
    "variable": "var(--colors-color-palette-quaternary-300)"
  },
  "colors.colorPalette.quaternary.500": {
    "value": "var(--colors-color-palette-quaternary-500)",
    "variable": "var(--colors-color-palette-quaternary-500)"
  },
  "colors.colorPalette.quaternary.600": {
    "value": "var(--colors-color-palette-quaternary-600)",
    "variable": "var(--colors-color-palette-quaternary-600)"
  },
  "colors.colorPalette.inbound": {
    "value": "var(--colors-color-palette-inbound)",
    "variable": "var(--colors-color-palette-inbound)"
  },
  "colors.colorPalette.outbound": {
    "value": "var(--colors-color-palette-outbound)",
    "variable": "var(--colors-color-palette-outbound)"
  },
  "colors.colorPalette.autoReply": {
    "value": "var(--colors-color-palette-auto-reply)",
    "variable": "var(--colors-color-palette-auto-reply)"
  },
  "colors.colorPalette.bodyBackground": {
    "value": "var(--colors-color-palette-body-background)",
    "variable": "var(--colors-color-palette-body-background)"
  },
  "colors.colorPalette.contentBackground": {
    "value": "var(--colors-color-palette-content-background)",
    "variable": "var(--colors-color-palette-content-background)"
  },
  "colors.colorPalette.contentBorder": {
    "value": "var(--colors-color-palette-content-border)",
    "variable": "var(--colors-color-palette-content-border)"
  },
  "colors.colorPalette.sidebar.darkbg": {
    "value": "var(--colors-color-palette-sidebar-darkbg)",
    "variable": "var(--colors-color-palette-sidebar-darkbg)"
  },
  "colors.colorPalette.darkbg": {
    "value": "var(--colors-color-palette-darkbg)",
    "variable": "var(--colors-color-palette-darkbg)"
  },
  "colors.colorPalette.sidebar.lightbg": {
    "value": "var(--colors-color-palette-sidebar-lightbg)",
    "variable": "var(--colors-color-palette-sidebar-lightbg)"
  },
  "colors.colorPalette.lightbg": {
    "value": "var(--colors-color-palette-lightbg)",
    "variable": "var(--colors-color-palette-lightbg)"
  },
  "colors.colorPalette.sidebar.text": {
    "value": "var(--colors-color-palette-sidebar-text)",
    "variable": "var(--colors-color-palette-sidebar-text)"
  },
  "colors.colorPalette.text": {
    "value": "var(--colors-color-palette-text)",
    "variable": "var(--colors-color-palette-text)"
  },
  "colors.colorPalette.sidebar.headerText": {
    "value": "var(--colors-color-palette-sidebar-header-text)",
    "variable": "var(--colors-color-palette-sidebar-header-text)"
  },
  "colors.colorPalette.headerText": {
    "value": "var(--colors-color-palette-header-text)",
    "variable": "var(--colors-color-palette-header-text)"
  },
  "colors.colorPalette.bg": {
    "value": "var(--colors-color-palette-bg)",
    "variable": "var(--colors-color-palette-bg)"
  },
  "colors.colorPalette.header.title": {
    "value": "var(--colors-color-palette-header-title)",
    "variable": "var(--colors-color-palette-header-title)"
  },
  "colors.colorPalette.title": {
    "value": "var(--colors-color-palette-title)",
    "variable": "var(--colors-color-palette-title)"
  },
  "colors.colorPalette.header.subtitle": {
    "value": "var(--colors-color-palette-header-subtitle)",
    "variable": "var(--colors-color-palette-header-subtitle)"
  },
  "colors.colorPalette.subtitle": {
    "value": "var(--colors-color-palette-subtitle)",
    "variable": "var(--colors-color-palette-subtitle)"
  },
  "colors.colorPalette.borderColor": {
    "value": "var(--colors-color-palette-border-color)",
    "variable": "var(--colors-color-palette-border-color)"
  }
}

export function token(path, fallback) {
  return tokens[path]?.value || fallback
}

function tokenVar(path, fallback) {
  return tokens[path]?.variable || fallback
}

token.var = tokenVar